
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2iFkw", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $e0SBo = parcelRequire("e0SBo");

var $cFEpk = parcelRequire("cFEpk");

var $da71s = parcelRequire("da71s");


var $aXjWU = parcelRequire("aXjWU");


var $euL71 = parcelRequire("euL71");


var $9wGTI = parcelRequire("9wGTI");


var $b3j2Y = parcelRequire("b3j2Y");


var $0g3Y7 = parcelRequire("0g3Y7");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $jmjWc = parcelRequire("jmjWc");


const $c3062fd9bd4bc3d6$export$fbc613eb80844f6d = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "krxqH",
    name: "PremiumTrialDigestDataModal",
    loader: async ()=>(await (parcelRequire("9bxvy"))).PremiumTrialDigestDataModal
});



var $3F1Fd = parcelRequire("3F1Fd");


var $8Lx5S = parcelRequire("8Lx5S");


var $gqypm = parcelRequire("gqypm");











var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $T1bCI = parcelRequire("T1bCI");


var $2Nwuj = parcelRequire("2Nwuj");


var $kRW4Y = parcelRequire("kRW4Y");

















var $inPa6 = parcelRequire("inPa6");

var $d9d57715caf43e35$exports = {};
$d9d57715caf43e35$exports = new URL("Automation-Light.4cbefa6a.svg", import.meta.url).toString();


var $4599f83549ba50bf$exports = {};
$4599f83549ba50bf$exports = new URL("Automation-Dark.46b5333b.svg", import.meta.url).toString();


const $730d60ea08007f73$export$9eda3708269a0f96 = (title, body, userPrivilege)=>{
    return {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), title),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($730d60ea08007f73$var$AutomationSlideBody, {
            body: body,
            userPrivilege: userPrivilege
        }),
        imageUrlLight: (0, (/*@__PURE__*/$parcel$interopDefault($d9d57715caf43e35$exports))),
        imageUrlDark: (0, (/*@__PURE__*/$parcel$interopDefault($4599f83549ba50bf$exports)))
    };
};
const $730d60ea08007f73$var$AutomationSlideBody = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { body: body, userPrivilege: userPrivilege } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== userPrivilege) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "automationPremiumOnboarding",
                    attributes: {
                        userPrivilege: `${userPrivilege}`
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            userPrivilege
        ];
        $[0] = createAnalyticsEvent;
        $[1] = userPrivilege;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== userPrivilege) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: "automationPremiumOnboarding",
                    attributes: {
                        userPrivilege: `${userPrivilege}`
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = userPrivilege;
        $[6] = t3;
    } else t3 = $[6];
    const handleOnClick = t3;
    let t4;
    if ($[7] !== handleOnClick) {
        t4 = {
            automationLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: "https://support.atlassian.com/confluence-cloud/docs/what-is-confluence-automation/",
                    target: "_blank",
                    onClick: handleOnClick
                }, chunks)
        };
        $[7] = handleOnClick;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== body || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            ...body,
            values: t4
        });
        $[9] = body;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ body: body, userPrivilege: userPrivilege })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'automationPremiumOnboarding',
                attributes: {
                    userPrivilege: `${userPrivilege}`
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        userPrivilege
    ]);
    const handleOnClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'automationPremiumOnboarding',
                attributes: {
                    userPrivilege: `${userPrivilege}`
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        ...body,
        values: {
            automationLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: "https://support.atlassian.com/confluence-cloud/docs/what-is-confluence-automation/",
                    target: "_blank",
                    onClick: handleOnClick
                }, chunks)
        }
    });
};




















var $7590bd2bdf6a9629$exports = {};
$7590bd2bdf6a9629$exports = new URL("Whiteboards-Light.44741238.svg", import.meta.url).toString();


var $eec54ce602325c4d$exports = {};
$eec54ce602325c4d$exports = new URL("Whiteboards-Dark.099e653c.svg", import.meta.url).toString();


const $6bc5cb3d26920862$export$2a09be80519f9300 = (title, body, userPrivilege)=>({
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), title),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6bc5cb3d26920862$var$WhiteboardsSlideBody, {
            body: body,
            userPrivilege: userPrivilege
        }),
        // Place holder while
        imageUrlLight: (0, (/*@__PURE__*/$parcel$interopDefault($7590bd2bdf6a9629$exports))),
        imageUrlDark: (0, (/*@__PURE__*/$parcel$interopDefault($eec54ce602325c4d$exports)))
    });
const $6bc5cb3d26920862$export$52c151d0b5c117a2 = 'whiteboards-premium-onboarding-learn-more-link';
const $6bc5cb3d26920862$var$WhiteboardsSlideBody = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { body: body, userPrivilege: userPrivilege } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== userPrivilege) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "whiteboardsPremiumOnboarding",
                    attributes: {
                        userPrivilege: `${userPrivilege}`
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            userPrivilege
        ];
        $[0] = createAnalyticsEvent;
        $[1] = userPrivilege;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== userPrivilege) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: "whiteboardsPremiumOnboardingLearnMoreLink",
                    attributes: {
                        userPrivilege: `${userPrivilege}`
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = userPrivilege;
        $[6] = t3;
    } else t3 = $[6];
    const handleOnClick = t3;
    let t4;
    if ($[7] !== handleOnClick) {
        t4 = {
            learnMoreLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: "https://www.atlassian.com/software/confluence/whiteboards",
                    target: "_blank",
                    testId: $6bc5cb3d26920862$export$52c151d0b5c117a2,
                    onClick: handleOnClick
                }, chunks)
        };
        $[7] = handleOnClick;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== body || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            ...body,
            values: t4
        });
        $[9] = body;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ body: body, userPrivilege: userPrivilege })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'whiteboardsPremiumOnboarding',
                attributes: {
                    userPrivilege: `${userPrivilege}`
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        userPrivilege
    ]);
    const handleOnClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'whiteboardsPremiumOnboardingLearnMoreLink',
                attributes: {
                    userPrivilege: `${userPrivilege}`
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        ...body,
        values: {
            learnMoreLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: "https://www.atlassian.com/software/confluence/whiteboards",
                    target: "_blank",
                    testId: $6bc5cb3d26920862$export$52c151d0b5c117a2,
                    onClick: handleOnClick
                }, chunks)
        }
    });
};


/* OnboardingModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $8TTLA = parcelRequire("8TTLA");

var $8CZUH = parcelRequire("8CZUH");


var $cOrQJ = parcelRequire("cOrQJ");


var $gdv5Z = parcelRequire("gdv5Z");











var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");





var $eEA8O = parcelRequire("eEA8O");


var $jZuqn = parcelRequire("jZuqn");


var $8o1lj = parcelRequire("8o1lj");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $965e4fddf9b09696$var$StyledFlexContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc _1bsb1osq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $965e4fddf9b09696$var$StyledFlexColumn = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { align: align, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_f3maaz": (0, $7sObp.default)(__cmplp.align)
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.align ? "_y3gnsch7" : "_y3gn1kw7",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { align: align, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_f3maaz": (0, $7sObp.default)(__cmplp.align)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.align ? "_y3gnsch7" : "_y3gn1kw7",
            __cmplp.className
        ])
    });
});
const $965e4fddf9b09696$var$StyledProgressDots = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkutpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkutpp",
            __cmplp.className
        ])
    });
});
const $965e4fddf9b09696$export$18a9bd789e1db9dc = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { selectedIndex: selectedIndex, isLastSlide: isLastSlide, onSkip: onSkip, onNext: onNext, slides: slides } = t0;
    let t1;
    if ($[0] !== slides) {
        t1 = slides.map($965e4fddf9b09696$var$_temp);
        $[0] = slides;
        $[1] = t1;
    } else t1 = $[1];
    const slideTitles = t1;
    const numOfSlides = slides.length;
    const currentSlideUrl = slides[selectedIndex].learnMoreUrl;
    let t2;
    if ($[2] !== currentSlideUrl || $[3] !== isLastSlide || $[4] !== onNext) {
        t2 = ()=>currentSlideUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "primary",
                href: currentSlideUrl,
                target: "_blank"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                id: "premium-onboarding.button.learn.more",
                defaultMessage: "Learn more"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                onClick: onNext,
                appearance: "primary"
            }, isLastSlide ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                id: "premium-onboarding.button.done",
                defaultMessage: "Done"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                id: "premium-onboarding.button.next",
                defaultMessage: "Next"
            }));
        $[2] = currentSlideUrl;
        $[3] = isLastSlide;
        $[4] = onNext;
        $[5] = t2;
    } else t2 = $[5];
    const renderPrimaryCTA = t2;
    let t3;
    if ($[6] !== onSkip) {
        t3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "subtle-link",
                onClick: onSkip
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                id: "premium-onboarding.button.dismiss",
                defaultMessage: "Dismiss"
            }));
        $[6] = onSkip;
        $[7] = t3;
    } else t3 = $[7];
    const renderSecondaryCTA = t3;
    let t4;
    if ($[8] !== selectedIndex || $[9] !== slideTitles) {
        t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($965e4fddf9b09696$var$StyledProgressDots, {
                "data-testid": "progress-indicator"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jZuqn.default), {
                selectedIndex: selectedIndex,
                values: slideTitles
            }));
        $[8] = selectedIndex;
        $[9] = slideTitles;
        $[10] = t4;
    } else t4 = $[10];
    const renderProgressIndicator = t4;
    let t5;
    if ($[11] !== renderSecondaryCTA) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($965e4fddf9b09696$var$StyledFlexColumn, null, renderSecondaryCTA());
        $[11] = renderSecondaryCTA;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== numOfSlides || $[14] !== renderProgressIndicator) {
        t6 = numOfSlides < 2 ? null : renderProgressIndicator();
        $[13] = numOfSlides;
        $[14] = renderProgressIndicator;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($965e4fddf9b09696$var$StyledFlexColumn, null, t6);
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== renderPrimaryCTA) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($965e4fddf9b09696$var$StyledFlexColumn, {
            align: "right"
        }, renderPrimaryCTA());
        $[18] = renderPrimaryCTA;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== t5 || $[21] !== t7 || $[22] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($965e4fddf9b09696$var$StyledFlexContainer, null, t5, t7, t8));
        $[20] = t5;
        $[21] = t7;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    return t9;
} : ({ selectedIndex: selectedIndex, isLastSlide: isLastSlide, onSkip: onSkip, onNext: onNext, slides: slides })=>{
    const slideTitles = slides.map((slide)=>slide.title);
    const numOfSlides = slides.length;
    const currentSlideUrl = slides[selectedIndex].learnMoreUrl;
    const renderPrimaryCTA = ()=>currentSlideUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "primary",
            href: currentSlideUrl,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            id: "premium-onboarding.button.learn.more",
            defaultMessage: "Learn more"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            onClick: onNext,
            appearance: "primary"
        }, isLastSlide ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            id: "premium-onboarding.button.done",
            defaultMessage: "Done"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            id: "premium-onboarding.button.next",
            defaultMessage: "Next"
        }));
    const renderSecondaryCTA = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle-link",
            onClick: onSkip
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            id: "premium-onboarding.button.dismiss",
            defaultMessage: "Dismiss"
        }));
    const renderProgressIndicator = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($965e4fddf9b09696$var$StyledProgressDots, {
            "data-testid": "progress-indicator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jZuqn.default), {
            selectedIndex: selectedIndex,
            values: slideTitles
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($965e4fddf9b09696$var$StyledFlexContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($965e4fddf9b09696$var$StyledFlexColumn, null, renderSecondaryCTA()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($965e4fddf9b09696$var$StyledFlexColumn, null, numOfSlides < 2 ? null : renderProgressIndicator()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($965e4fddf9b09696$var$StyledFlexColumn, {
        align: "right"
    }, renderPrimaryCTA())));
};
function $965e4fddf9b09696$var$_temp(slide) {
    return slide.title;
}

















var $1cfRh = parcelRequire("1cfRh");


var $6R5uz = parcelRequire("6R5uz");


var $laHi9 = parcelRequire("laHi9");














var $gj7hi = parcelRequire("gj7hi");

const $cbfc4d4967755378$var$modalImage = null;
const $cbfc4d4967755378$export$1355685fd5f8d257 = (0, $3u0dr.isReactCompilerActiveV2)() ? function ModalImage(t0) {
    const $ = (0, $frIzR.c)(5);
    const { src: src, srcDark: srcDark, alt: alt } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_kqswstnw _1bsb1osq _4t3iaq80 _5ral1dfr _rsuf1h6o"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== alt || $[2] !== src || $[3] !== srcDark) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: src,
            srcDark: srcDark,
            alt: alt,
            className: t1
        });
        $[1] = alt;
        $[2] = src;
        $[3] = srcDark;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function ModalImage({ src: src, srcDark: srcDark, alt: alt }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: src,
        srcDark: srcDark,
        alt: alt,
        className: (0, $gMc0m.default)([
            "_kqswstnw _1bsb1osq _4t3iaq80 _5ral1dfr _rsuf1h6o"
        ])
    });
};


const $df20ad2fbd79a462$var$i18n = (0, $h82at.defineMessages)({
    imageAltText: {
        id: "premium-onboarding.modal.image.alt-text",
        defaultMessage: "Feature illustration for this onboarding step"
    }
});
// Global constants
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df20ad2fbd79a462$var$StyledBody = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4oahv _y3gn1h6o _4t3i53f4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4oahv _y3gn1h6o _4t3i53f4",
            __cmplp.className
        ])
    });
});
const $df20ad2fbd79a462$var$StyledImageWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTransparent: isTransparent, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1osq _4t3ieoa3 _c71leoa3 _kqswh2mm _13lifajl _qrwqfajl",
            __cmplp.isTransparent ? "_bfhk1j28" : "_bfhktdv8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTransparent: isTransparent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3ieoa3 _c71leoa3 _kqswh2mm _13lifajl _qrwqfajl",
            __cmplp.isTransparent ? "_bfhk1j28" : "_bfhktdv8",
            __cmplp.className
        ])
    });
});
const $df20ad2fbd79a462$var$OldStyledChevronButton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q7idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu2glyw _12y3idpf _19itidpf _1bsb1ul9 _80omtlke _19pk53f4 _tzy415iw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu2glyw _12y3idpf _19itidpf _1bsb1ul9 _80omtlke _19pk53f4 _tzy415iw",
            __cmplp.className
        ])
    });
});
const $df20ad2fbd79a462$var$StyledChevronButton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $df20ad2fbd79a462$var$OldStyledChevronButton : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1rr0 _4t3i1ul9 _bfhk1i45",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = $df20ad2fbd79a462$var$OldStyledChevronButton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _4t3i1ul9 _bfhk1i45",
            __cmplp.className
        ])
    });
});
const $df20ad2fbd79a462$var$StyledFlexedButtons = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41lhn _4t3i1osq _1e0c1txw _2lx2vrvc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41lhn _4t3i1osq _1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $df20ad2fbd79a462$var$StyledButtonLeft = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _y3gn1e5h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _y3gn1e5h",
            __cmplp.className
        ])
    });
});
const $df20ad2fbd79a462$var$StyledButtonRight = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _y3gnusic",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _y3gnusic",
            __cmplp.className
        ])
    });
});
const $df20ad2fbd79a462$var$StyledHeading = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "h2" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c81af2 _otyrv47k",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81af2 _otyrv47k",
            __cmplp.className
        ])
    });
});
const $df20ad2fbd79a462$export$b8ae7026cf819bae = (0, $3u0dr.isReactCompilerActiveV2)() ? function OnboardingModalBody(t0) {
    const $ = (0, $frIzR.c)(27);
    const { selectedIndex: selectedIndex, isFirstSlide: isFirstSlide, isLastSlide: isLastSlide, onPrev: onPrev, onNext: onNext, slides: slides } = t0;
    const intl = (0, $1cfRh.default)();
    const { title: title, body: body, imageUrlLight: imageUrlLight, imageUrlDark: imageUrlDark, isTransparentBackground: isTransparentBackground } = slides[selectedIndex];
    let t1;
    if ($[0] !== isFirstSlide || $[1] !== isLastSlide || $[2] !== onNext || $[3] !== onPrev) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledFlexedButtons, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledButtonLeft, null, !isFirstSlide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledChevronButton, {
                onClick: onPrev
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                label: "previous-slide-chevron",
                color: "var(--ds-icon-inverse, #FFFFFF)",
                size: "small"
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledButtonRight, null, !isLastSlide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledChevronButton, {
                onClick: onNext
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                label: "next-slide-chevron",
                color: "var(--ds-icon-inverse, #FFFFFF)",
                size: "small"
            }))));
        $[0] = isFirstSlide;
        $[1] = isLastSlide;
        $[2] = onNext;
        $[3] = onPrev;
        $[4] = t1;
    } else t1 = $[4];
    const renderChevrons = t1;
    let t2;
    if ($[5] !== intl) {
        t2 = intl.formatMessage($df20ad2fbd79a462$var$i18n.imageAltText);
        $[5] = intl;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== imageUrlDark || $[8] !== imageUrlLight || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbfc4d4967755378$export$1355685fd5f8d257), {
            src: imageUrlLight,
            srcDark: imageUrlDark,
            alt: t2
        });
        $[7] = imageUrlDark;
        $[8] = imageUrlLight;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== renderChevrons) {
        t4 = renderChevrons();
        $[11] = renderChevrons;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== isTransparentBackground || $[14] !== t3 || $[15] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledImageWrapper, {
            isTransparent: isTransparentBackground
        }, t3, t4);
        $[13] = isTransparentBackground;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== title) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledHeading, null, title);
        $[17] = title;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== body) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, body);
        $[19] = body;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== t6 || $[22] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledBody, null, t6, t7);
        $[21] = t6;
        $[22] = t7;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== t5 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t5, t8);
        $[24] = t5;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : function OnboardingModalBody({ selectedIndex: selectedIndex, isFirstSlide: isFirstSlide, isLastSlide: isLastSlide, onPrev: onPrev, onNext: onNext, slides: slides }) {
    const intl = (0, $1cfRh.default)();
    const { title: title, body: body, imageUrlLight: imageUrlLight, imageUrlDark: imageUrlDark, isTransparentBackground: isTransparentBackground } = slides[selectedIndex];
    const renderChevrons = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledFlexedButtons, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledButtonLeft, null, !isFirstSlide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledChevronButton, {
            onClick: onPrev
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
            label: "previous-slide-chevron",
            color: "var(--ds-icon-inverse, #FFFFFF)",
            size: "small"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledButtonRight, null, !isLastSlide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledChevronButton, {
            onClick: onNext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            label: "next-slide-chevron",
            color: "var(--ds-icon-inverse, #FFFFFF)",
            size: "small"
        }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledImageWrapper, {
        isTransparent: isTransparentBackground
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbfc4d4967755378$export$1355685fd5f8d257), {
        src: imageUrlLight,
        srcDark: imageUrlDark,
        alt: intl.formatMessage($df20ad2fbd79a462$var$i18n.imageAltText)
    }), renderChevrons()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df20ad2fbd79a462$var$StyledHeading, null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, body)));
};


const $c8e43b454ed71d9c$var$onboardingModalStyles = {
    modalInnerWrapper: "_kqswh2mm _4t3i1osq",
    closeButtonWrapper: "_kqswstnw _1xi2idpf _1pbykb7n"
};
function $c8e43b454ed71d9c$export$1f25f0c7529b70a5({ slides: slides, onClose: onClose }) {
    // States
    const [slideIndex, setSlideIndex] = (0, $42omo.useState)(0);
    const theme = (0, $cOrQJ.default)(); // Image preloader
    (0, $42omo.useEffect)(()=>{
        slides.forEach((slide)=>{
            if (slide.imageUrlLight || slide.imageUrlDark) {
                const preloadedImage = new Image();
                preloadedImage.src = theme.colorMode === 'dark' ? slide.imageUrlDark : slide.imageUrlLight;
            }
        });
    }, [
        slides,
        theme
    ]);
    // Helpers
    const isLastSlide = slideIndex + 1 === slides.length;
    const isFirstSlide = slideIndex === 0; // Callbacks (memoized)
    const onPrev = (0, $42omo.useCallback)(()=>{
        !isFirstSlide && setSlideIndex(slideIndex - 1);
    }, [
        isFirstSlide,
        setSlideIndex,
        slideIndex
    ]);
    const onSkip = (0, $42omo.useCallback)(onClose, [
        onClose
    ]);
    const onNext = (0, $42omo.useCallback)(()=>{
        isLastSlide ? onClose() : setSlideIndex(slideIndex + 1);
    }, [
        isLastSlide,
        onClose,
        setSlideIndex,
        slideIndex
    ]); // UI functions
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        onClose: onClose,
        width: 550,
        label: "Onboarding modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c8e43b454ed71d9c$var$onboardingModalStyles.modalInnerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c8e43b454ed71d9c$var$onboardingModalStyles.closeButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: onClose
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $df20ad2fbd79a462$export$b8ae7026cf819bae), {
        selectedIndex: slideIndex,
        isLastSlide: isLastSlide,
        isFirstSlide: isFirstSlide,
        onPrev: onPrev,
        onNext: onNext,
        slides: slides
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $965e4fddf9b09696$export$18a9bd789e1db9dc), {
        selectedIndex: slideIndex,
        isLastSlide: isLastSlide,
        onSkip: onSkip,
        onNext: onNext,
        slides: slides
    })));
}


var $eda59732629ac774$exports = {};
$eda59732629ac774$exports = new URL("Universe-Light.4a82a36e.svg", import.meta.url).toString();


var $f7ce2b9750a3f2d1$exports = {};
$f7ce2b9750a3f2d1$exports = new URL("Universe-Dark.aa971277.svg", import.meta.url).toString();


var $e92a5a93e408e8db$exports = {};
$e92a5a93e408e8db$exports = new URL("Decisions-Light.4c21a454.svg", import.meta.url).toString();


var $11e7430b98a35a37$exports = {};
$11e7430b98a35a37$exports = new URL("Decisions-Dark.22625faf.svg", import.meta.url).toString();


var $29c92e4e3ed64eb6$exports = {};
$29c92e4e3ed64eb6$exports = new URL("Unlock-Light.b5906d5a.svg", import.meta.url).toString();


var $60fd4cbf85294d95$exports = {};
$60fd4cbf85294d95$exports = new URL("Unlock-Dark.ab086f98.svg", import.meta.url).toString();


var $6072bcaca0d9a5c5$exports = {};
$6072bcaca0d9a5c5$exports = new URL("Uptime-Light.f2a1259b.svg", import.meta.url).toString();


var $d4e525a4ef65b2bc$exports = {};
$d4e525a4ef65b2bc$exports = new URL("Uptime-Dark.b9eabd14.svg", import.meta.url).toString();


const $1f943a0e379aa69c$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    'slide-1-title': {
        id: "premium.admin.onboarding.slide1.title",
        defaultMessage: "Welcome to Confluence Cloud Premium"
    },
    'slide-2-automation-title': {
        id: "premium.admin.onboarding.slide2.automation.title",
        defaultMessage: "Automate your growing Confluence site"
    },
    'slide-2-title': {
        id: "premium.admin.onboarding.slide2.title",
        defaultMessage: "Make better decisions"
    },
    'slide-3-title': {
        id: "premium.admin.onboarding.slide3.title",
        defaultMessage: "Remove obstacles fast"
    },
    'slide-5-title': {
        id: "premium.admin.onboarding.slide5.title",
        defaultMessage: "Uptime, all the time"
    },
    'slide-1-body': {
        id: "premium.admin.onboarding.slide1.body",
        defaultMessage: "Scale effortlessly as your organization grows. You\u2019ve got more visibility, controls, and platform support to take team knowledge to the next level."
    },
    'slide-2-automation-body': {
        id: "premium.admin.onboarding.slide2.automation.body",
        defaultMessage: "<automationLink>Automation</automationLink> lets you track the content lifecycle, keep spaces organized, and notify teams about important tasks and deadlines."
    },
    'slide-2-body': {
        id: "premium.admin.onboarding.slide2.body",
        defaultMessage: "Use site, space, and page {analyticsLink} to report on project progress, team involvement, and popular content."
    },
    'slide-3-body': {
        id: "premium.admin.onboarding.slide3.body",
        defaultMessage: "Get {temporaryAccessLink} to restricted pages and {inspectUserPermissionsLink} on pages to solve access issues quickly and get your team back to work."
    },
    'slide-5-body': {
        id: "premium.admin.onboarding.slide5.body",
        defaultMessage: "Sleep well at night knowing that Confluence will be up and running around the clock. Premium includes a 99.9% uptime SLA, 24/7 support, and unlimited storage. {learnMore}"
    },
    'slide-whiteboards-title': {
        id: "premium.admin.onboarding.slide.whiteboards.title",
        defaultMessage: "Brainstorm with whiteboards"
    },
    'slide-whiteboards-body': {
        id: "premium.admin.onboarding.slide.whiteboards.body",
        defaultMessage: "Unlock access to advanced whiteboarding features like richer integrations with Jira and smart sections! <learnMoreLink>Learn more</learnMoreLink>"
    },
    'learn-more': {
        id: "premium.admin.onboarding.learn.more",
        defaultMessage: "Learn more"
    },
    'temporary-access': {
        id: "premium.admin.onboarding.temporary.access",
        defaultMessage: "temporary access"
    },
    'inspect-user-permissions': {
        id: "premium.admin.onboarding.inspect.user.permissions",
        defaultMessage: "inspect users\u2019 permissions"
    },
    analytics: {
        id: "premium.admin.onboarding.analytics",
        defaultMessage: "analytics"
    }
});
const $1f943a0e379aa69c$export$a0f4e1fa13a23780 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { stop: stop } = t0;
    const [dialogOpen, setDialogOpen] = (0, $42omo.useState)(false);
    let t1;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168["slide-1-title"]),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168["slide-1-body"]),
            imageUrlLight: (0, (/*@__PURE__*/$parcel$interopDefault($eda59732629ac774$exports))),
            imageUrlDark: (0, (/*@__PURE__*/$parcel$interopDefault($f7ce2b9750a3f2d1$exports)))
        };
        t2 = (0, $730d60ea08007f73$export$9eda3708269a0f96)($1f943a0e379aa69c$export$a7357cdd1f0b0168["slide-2-automation-title"], $1f943a0e379aa69c$export$a7357cdd1f0b0168["slide-2-automation-body"], "siteAdmin");
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168["slide-2-title"]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else {
        t1 = $[0];
        t2 = $[1];
        t3 = $[2];
    }
    let t4;
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            title: t3,
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                ...$1f943a0e379aa69c$export$a7357cdd1f0b0168["slide-2-body"],
                values: {
                    analyticsLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        href: "https://confluence.atlassian.com/display/ConfCloud/Analytics",
                        target: "_blank"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168.analytics))
                }
            }),
            imageUrlLight: (0, (/*@__PURE__*/$parcel$interopDefault($e92a5a93e408e8db$exports))),
            imageUrlDark: (0, (/*@__PURE__*/$parcel$interopDefault($11e7430b98a35a37$exports)))
        };
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168["slide-3-title"]);
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: "https://confluence.atlassian.com/display/ConfCloud/Access+a+page+with+admin+key",
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168["temporary-access"]));
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            title: t5,
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                ...$1f943a0e379aa69c$export$a7357cdd1f0b0168["slide-3-body"],
                values: {
                    temporaryAccessLink: t6,
                    inspectUserPermissionsLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        href: "https://confluence.atlassian.com/display/ConfCloud/Inspect+permissions",
                        target: "_blank"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168["inspect-user-permissions"]))
                }
            }),
            imageUrlLight: (0, (/*@__PURE__*/$parcel$interopDefault($29c92e4e3ed64eb6$exports))),
            imageUrlDark: (0, (/*@__PURE__*/$parcel$interopDefault($60fd4cbf85294d95$exports)))
        };
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168["slide-5-title"]);
        $[6] = t7;
        $[7] = t8;
    } else {
        t7 = $[6];
        t8 = $[7];
    }
    let t9;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = [
            t1,
            t2,
            t4,
            t7,
            {
                title: t8,
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                    ...$1f943a0e379aa69c$export$a7357cdd1f0b0168["slide-5-body"],
                    values: {
                        learnMore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                            href: "https://confluence.atlassian.com/x/W6T0OQ",
                            target: "_blank"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168["learn-more"]))
                    }
                }),
                imageUrlLight: (0, (/*@__PURE__*/$parcel$interopDefault($6072bcaca0d9a5c5$exports))),
                imageUrlDark: (0, (/*@__PURE__*/$parcel$interopDefault($d4e525a4ef65b2bc$exports)))
            },
            (0, $6bc5cb3d26920862$export$2a09be80519f9300)($1f943a0e379aa69c$export$a7357cdd1f0b0168["slide-whiteboards-title"], $1f943a0e379aa69c$export$a7357cdd1f0b0168["slide-whiteboards-body"], "siteAdmin")
        ];
        $[8] = t9;
    } else t9 = $[8];
    const ONBOARDING_SLIDES = t9;
    let t10;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== dialogOpen || $[11] !== stop) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t10
        }, (dialogs)=>{
            if (!dialogOpen) {
                setDialogOpen(true);
                dialogs.showDialog((0, $c8e43b454ed71d9c$export$1f25f0c7529b70a5), {
                    slides: ONBOARDING_SLIDES,
                    onClose: ()=>{
                        if (stop) stop();
                        else throw new Error("PremiumAdminOnboarding should be a child of PremiumOnboarding");
                    }
                });
            }
            return null;
        });
        $[10] = dialogOpen;
        $[11] = stop;
        $[12] = t11;
    } else t11 = $[12];
    return t11;
} : ({ stop: stop })=>{
    const [dialogOpen, setDialogOpen] = (0, $42omo.useState)(false);
    const ONBOARDING_SLIDES = [
        {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168['slide-1-title']),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168['slide-1-body']),
            imageUrlLight: (0, (/*@__PURE__*/$parcel$interopDefault($eda59732629ac774$exports))),
            imageUrlDark: (0, (/*@__PURE__*/$parcel$interopDefault($f7ce2b9750a3f2d1$exports)))
        },
        (0, $730d60ea08007f73$export$9eda3708269a0f96)($1f943a0e379aa69c$export$a7357cdd1f0b0168['slide-2-automation-title'], $1f943a0e379aa69c$export$a7357cdd1f0b0168['slide-2-automation-body'], 'siteAdmin'),
        {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168['slide-2-title']),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                ...$1f943a0e379aa69c$export$a7357cdd1f0b0168['slide-2-body'],
                values: {
                    analyticsLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        href: "https://confluence.atlassian.com/display/ConfCloud/Analytics",
                        target: "_blank"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168['analytics']))
                }
            }),
            imageUrlLight: (0, (/*@__PURE__*/$parcel$interopDefault($e92a5a93e408e8db$exports))),
            imageUrlDark: (0, (/*@__PURE__*/$parcel$interopDefault($11e7430b98a35a37$exports)))
        },
        {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168['slide-3-title']),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                ...$1f943a0e379aa69c$export$a7357cdd1f0b0168['slide-3-body'],
                values: {
                    temporaryAccessLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        href: "https://confluence.atlassian.com/display/ConfCloud/Access+a+page+with+admin+key",
                        target: "_blank"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168['temporary-access'])),
                    inspectUserPermissionsLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        href: "https://confluence.atlassian.com/display/ConfCloud/Inspect+permissions",
                        target: "_blank"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168['inspect-user-permissions']))
                }
            }),
            imageUrlLight: (0, (/*@__PURE__*/$parcel$interopDefault($29c92e4e3ed64eb6$exports))),
            imageUrlDark: (0, (/*@__PURE__*/$parcel$interopDefault($60fd4cbf85294d95$exports)))
        },
        {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168['slide-5-title']),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                ...$1f943a0e379aa69c$export$a7357cdd1f0b0168['slide-5-body'],
                values: {
                    learnMore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        href: "https://confluence.atlassian.com/x/W6T0OQ",
                        target: "_blank"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $1f943a0e379aa69c$export$a7357cdd1f0b0168['learn-more']))
                }
            }),
            imageUrlLight: (0, (/*@__PURE__*/$parcel$interopDefault($6072bcaca0d9a5c5$exports))),
            imageUrlDark: (0, (/*@__PURE__*/$parcel$interopDefault($d4e525a4ef65b2bc$exports)))
        },
        (0, $6bc5cb3d26920862$export$2a09be80519f9300)($1f943a0e379aa69c$export$a7357cdd1f0b0168['slide-whiteboards-title'], $1f943a0e379aa69c$export$a7357cdd1f0b0168['slide-whiteboards-body'], 'siteAdmin')
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>{
        if (!dialogOpen) {
            setDialogOpen(true);
            dialogs.showDialog((0, $c8e43b454ed71d9c$export$1f25f0c7529b70a5), {
                slides: ONBOARDING_SLIDES,
                onClose: ()=>{
                    if (stop) stop(); // tells EP's CoordinationClient to stop showing onboarding again
                    else throw new Error('PremiumAdminOnboarding should be a child of PremiumOnboarding');
                }
            });
        }
        return null;
    });
};























var $cyLm6 = parcelRequire("cyLm6");







var $ed421c284090c600$exports = {};
$ed421c284090c600$exports = new URL("Analytics.c6574472.svg", import.meta.url).toString();




const $e2563777a1d9d1e5$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    'slide-1-title': {
        id: "premium-onboarding.user.onboarding.slide1.title",
        defaultMessage: "Welcome to Confluence Cloud Premium"
    },
    'slide-2-title': {
        id: "premium-onboarding.user.onboarding.slide2.title",
        defaultMessage: "Create world-class content with analytics"
    },
    'slide-1-body': {
        id: "premium-onboarding.user.onboarding.slide1.body",
        defaultMessage: "Scale effortlessly as your organization grows. You\u2019ve got more analytics, new permissions tools, and bulk archiving to manage your content at scale."
    },
    'slide-2-body-p1': {
        id: "premium-onboarding.user.onboarding.slide2.body.p1",
        defaultMessage: "Use page and space analytics to find your most popular content and build on your success. Open {analytics} at the top of any page."
    },
    'slide-2-body-p2': {
        id: "premium-onboarding.user.onboarding.slide2.body.p2",
        defaultMessage: "You\u2019ve got analytics with {confluenceCloudPremium}. Take team knowledge to the next level!"
    },
    'learn-more': {
        id: "premium-onboarding.user.onboarding.learn.more",
        defaultMessage: "Learn more."
    },
    'confluence-cloud-premium': {
        id: "premium-onboarding.user.onboarding.confluence.cloud.premium",
        defaultMessage: "Confluence Cloud Premium"
    },
    'slide-2-automate-title': {
        id: "premium-onboarding.user.onboarding.slide2.automate.title",
        defaultMessage: "Automation keeps content organized"
    },
    'slide-2-automate-body': {
        id: "premium-onboarding.user.onboarding.slide2.automate.body",
        defaultMessage: "<automationLink>Automate</automationLink> recurring to-dos and processes in any space where you\u2019re an admin, including your personal space. This keeps spaces tidy and content up-to-date."
    },
    'slide-whiteboards-title': {
        id: "premium-onboarding.user.onboarding.slide.whiteboards.title",
        defaultMessage: "Whiteboard features"
    },
    'slide-whiteboards-body': {
        id: "premium-onboarding.user.onboarding.slide.whiteboards.body",
        defaultMessage: "Unlock access to advanced whiteboarding features like richer integrations with Jira and voting! <learnMoreLink>Learn more</learnMoreLink>"
    }
});
const $e2563777a1d9d1e5$var$StyledAnalyticsIcon = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0q1b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0q1b66",
            __cmplp.className
        ])
    });
});
const $e2563777a1d9d1e5$var$StyledConfluencePremiumLink = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $e2563777a1d9d1e5$export$40cf333f862b5beb = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { stop: stop } = t0;
    const [dialogOpen, setDialogOpen] = (0, $42omo.useState)(false);
    let t1;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e2563777a1d9d1e5$export$a7357cdd1f0b0168["slide-1-title"]),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e2563777a1d9d1e5$export$a7357cdd1f0b0168["slide-1-body"]),
            imageUrlLight: (0, (/*@__PURE__*/$parcel$interopDefault($eda59732629ac774$exports))),
            imageUrlDark: (0, (/*@__PURE__*/$parcel$interopDefault($f7ce2b9750a3f2d1$exports)))
        };
        t2 = (0, $730d60ea08007f73$export$9eda3708269a0f96)($e2563777a1d9d1e5$export$a7357cdd1f0b0168["slide-2-automate-title"], $e2563777a1d9d1e5$export$a7357cdd1f0b0168["slide-2-automate-body"], "user");
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e2563777a1d9d1e5$export$a7357cdd1f0b0168["slide-2-title"]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else {
        t1 = $[0];
        t2 = $[1];
        t3 = $[2];
    }
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e2563777a1d9d1e5$var$StyledAnalyticsIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))), {
            label: "analytics"
        }));
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            ...$e2563777a1d9d1e5$export$a7357cdd1f0b0168["slide-2-body-p1"],
            tagName: "p",
            values: {
                analytics: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t4, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                    id: "premium-onboarding.user.onboarding.analytics",
                    defaultMessage: "Analytics",
                    tagName: "strong"
                }))
            }
        });
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = [
            t1,
            t2,
            {
                title: t3,
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                    ...$e2563777a1d9d1e5$export$a7357cdd1f0b0168["slide-2-body-p2"],
                    tagName: "p",
                    values: {
                        confluenceCloudPremium: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e2563777a1d9d1e5$var$StyledConfluencePremiumLink, {
                            href: "https://confluence.atlassian.com/x/W6T0OQ",
                            target: "_blank"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e2563777a1d9d1e5$export$a7357cdd1f0b0168["confluence-cloud-premium"]))
                    }
                })),
                imageUrlLight: (0, (/*@__PURE__*/$parcel$interopDefault($ed421c284090c600$exports))),
                imageUrlDark: (0, (/*@__PURE__*/$parcel$interopDefault($ed421c284090c600$exports)))
            },
            (0, $6bc5cb3d26920862$export$2a09be80519f9300)($e2563777a1d9d1e5$export$a7357cdd1f0b0168["slide-whiteboards-title"], $e2563777a1d9d1e5$export$a7357cdd1f0b0168["slide-whiteboards-body"], "user")
        ];
        $[5] = t6;
    } else t6 = $[5];
    const ONBOARDING_SLIDES = t6;
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== dialogOpen || $[8] !== stop) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t7
        }, (dialogs)=>{
            if (!dialogOpen) {
                setDialogOpen(true);
                dialogs.showDialog((0, $c8e43b454ed71d9c$export$1f25f0c7529b70a5), {
                    slides: ONBOARDING_SLIDES,
                    onClose: ()=>{
                        if (stop) stop();
                        else throw new Error("PremiumUserOnboarding should be a child of PremiumOnboarding");
                    }
                });
            }
            return null;
        });
        $[7] = dialogOpen;
        $[8] = stop;
        $[9] = t8;
    } else t8 = $[9];
    return t8;
} : ({ stop: stop })=>{
    const [dialogOpen, setDialogOpen] = (0, $42omo.useState)(false);
    const ONBOARDING_SLIDES = [
        {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e2563777a1d9d1e5$export$a7357cdd1f0b0168['slide-1-title']),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e2563777a1d9d1e5$export$a7357cdd1f0b0168['slide-1-body']),
            imageUrlLight: (0, (/*@__PURE__*/$parcel$interopDefault($eda59732629ac774$exports))),
            imageUrlDark: (0, (/*@__PURE__*/$parcel$interopDefault($f7ce2b9750a3f2d1$exports)))
        },
        (0, $730d60ea08007f73$export$9eda3708269a0f96)($e2563777a1d9d1e5$export$a7357cdd1f0b0168['slide-2-automate-title'], $e2563777a1d9d1e5$export$a7357cdd1f0b0168['slide-2-automate-body'], 'user'),
        {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e2563777a1d9d1e5$export$a7357cdd1f0b0168['slide-2-title']),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                ...$e2563777a1d9d1e5$export$a7357cdd1f0b0168['slide-2-body-p1'],
                tagName: "p",
                values: {
                    analytics: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e2563777a1d9d1e5$var$StyledAnalyticsIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))), {
                        label: "analytics"
                    })), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                        id: "premium-onboarding.user.onboarding.analytics",
                        defaultMessage: "Analytics",
                        tagName: "strong"
                    }))
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                ...$e2563777a1d9d1e5$export$a7357cdd1f0b0168['slide-2-body-p2'],
                tagName: "p",
                values: {
                    confluenceCloudPremium: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e2563777a1d9d1e5$var$StyledConfluencePremiumLink, {
                        href: "https://confluence.atlassian.com/x/W6T0OQ",
                        target: "_blank"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e2563777a1d9d1e5$export$a7357cdd1f0b0168['confluence-cloud-premium']))
                }
            })),
            imageUrlLight: (0, (/*@__PURE__*/$parcel$interopDefault($ed421c284090c600$exports))),
            imageUrlDark: (0, (/*@__PURE__*/$parcel$interopDefault($ed421c284090c600$exports)))
        },
        (0, $6bc5cb3d26920862$export$2a09be80519f9300)($e2563777a1d9d1e5$export$a7357cdd1f0b0168['slide-whiteboards-title'], $e2563777a1d9d1e5$export$a7357cdd1f0b0168['slide-whiteboards-body'], 'user')
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>{
        if (!dialogOpen) {
            setDialogOpen(true);
            dialogs.showDialog((0, $c8e43b454ed71d9c$export$1f25f0c7529b70a5), {
                slides: ONBOARDING_SLIDES,
                onClose: ()=>{
                    if (stop) stop(); // tells EP's CoordinationClient to stop showing onboarding again
                    else throw new Error('PremiumUserOnboarding should be a child of PremiumOnboarding');
                }
            });
        }
        return null;
    });
};



var $jupik = parcelRequire("jupik");


var $bC5Yk = parcelRequire("bC5Yk");


var $eXOow = parcelRequire("eXOow");











var $9oxdN = parcelRequire("9oxdN");


var $3qv1u = parcelRequire("3qv1u");

const $3930d3a1cd3fdaa5$var$MID_TRIAL_PREMIUM_ONBOARDING_MODAL = 'mid-trial-premium-onboarding-modal';
const $3930d3a1cd3fdaa5$export$16232afca5e2d5d1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { isPremiumOnboardingFeatureDiscoveryEnabled: isPremiumOnboardingFeatureDiscoveryEnabled, isSiteAdmin: isSiteAdmin, isTrialHalfWayThrough: isTrialHalfWayThrough } = t0;
    const isEligibleToShowMidTrialModal = isPremiumOnboardingFeatureDiscoveryEnabled && isTrialHalfWayThrough;
    const t1 = !isEligibleToShowMidTrialModal || isSiteAdmin;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            skip: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const { totalFeaturesUsed: totalFeaturesUsed } = (0, $3qv1u.usePremiumFeatureUsage)(t2);
    const [shouldShowModal, stopModal] = (0, $9oxdN.useFeatureDiscovery)($3930d3a1cd3fdaa5$var$MID_TRIAL_PREMIUM_ONBOARDING_MODAL, totalFeaturesUsed == 0);
    const [shouldShowMidTrialPremiumOnboardingModal, setShouldShowMidTrialPremiumOnboardingModal] = (0, $42omo.useState)(false);
    let t3;
    let t4;
    if ($[2] !== shouldShowModal) {
        t3 = ()=>{
            if (shouldShowModal) setShouldShowMidTrialPremiumOnboardingModal(true);
        };
        t4 = [
            shouldShowModal
        ];
        $[2] = shouldShowModal;
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[5] !== shouldShowMidTrialPremiumOnboardingModal || $[6] !== stopModal) {
        t5 = {
            shouldShowMidTrialPremiumOnboardingModal: shouldShowMidTrialPremiumOnboardingModal,
            stopMidTrialPremiumOnboardingModal: stopModal
        };
        $[5] = shouldShowMidTrialPremiumOnboardingModal;
        $[6] = stopModal;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ isPremiumOnboardingFeatureDiscoveryEnabled: isPremiumOnboardingFeatureDiscoveryEnabled, isSiteAdmin: isSiteAdmin, isTrialHalfWayThrough: isTrialHalfWayThrough })=>{
    const isEligibleToShowMidTrialModal = isPremiumOnboardingFeatureDiscoveryEnabled && isTrialHalfWayThrough;
    const { totalFeaturesUsed: totalFeaturesUsed } = (0, $3qv1u.usePremiumFeatureUsage)({
        skip: !isEligibleToShowMidTrialModal || isSiteAdmin
    });
    /**
   * Productionization note:
   * Remove this block
   * return shouldShowMidTrialPremiumOnboardingModal: totalFeaturesUsed > 0
   */ const [shouldShowModal, stopModal] = (0, $9oxdN.useFeatureDiscovery)($3930d3a1cd3fdaa5$var$MID_TRIAL_PREMIUM_ONBOARDING_MODAL, /*skip */ totalFeaturesUsed == 0);
    const [shouldShowMidTrialPremiumOnboardingModal, setShouldShowMidTrialPremiumOnboardingModal] = (0, $42omo.useState)(false);
    // prevent state update when shouldShowModal becoming false due to stopModal is called
    (0, $42omo.useEffect)(()=>{
        if (shouldShowModal) setShouldShowMidTrialPremiumOnboardingModal(true);
    }, [
        shouldShowModal
    ]);
    return {
        shouldShowMidTrialPremiumOnboardingModal: shouldShowMidTrialPremiumOnboardingModal,
        stopMidTrialPremiumOnboardingModal: stopModal
    };
};




















var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $cO1el = parcelRequire("cO1el");


var $hmuev = parcelRequire("hmuev");





var $6xdDU = parcelRequire("6xdDU");








var $cvXh8 = parcelRequire("cvXh8");


var $fxBfz = parcelRequire("fxBfz");


var $8DN9t = parcelRequire("8DN9t");





var $f7Bnv = parcelRequire("f7Bnv");


var $dqdrq = parcelRequire("dqdrq");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $lsxnT = parcelRequire("lsxnT");


var $9iADO = parcelRequire("9iADO");


var $9eYxl = parcelRequire("9eYxl");


var $oCj79 = parcelRequire("oCj79");




const $9b6475faece45dc4$var$i18n = (0, $h82at.defineMessages)({
    modalBodyText: {
        id: "premium-onboarding.modal.body.text.pto.rt",
        defaultMessage: "Get started by exploring our {n, plural, one {# most popular feature} other {# most popular features}}."
    },
    additionalFeaturesTitle: {
        id: "premium-onboarding.title.additional.features",
        defaultMessage: "Plus:"
    },
    atlassianAIAdditionalFeatureText: {
        id: "premium-onboarding.text.additional.feature.atlassian.ai",
        defaultMessage: "Atlassian Intelligence (AI)"
    },
    whiteboardAdditionalFeatureText: {
        id: "premium-onboarding.text.additional.feature.whiteboard",
        defaultMessage: "Unlimited whiteboards and storage"
    },
    bulkContentToolsAdditionalFeatureText: {
        id: "premium-onboarding.text.additional.feature.bulk.content.tools",
        defaultMessage: "Bulk content management tools"
    },
    advancePermissionsAdditionalFeatureText: {
        id: "premium-onboarding.text.additional.feature.advance.permissions",
        defaultMessage: "Advanced permissions"
    }
});
const $9b6475faece45dc4$var$imageContainerStyles = (0, $ecnYn.xcss)({
    width: '145',
    minInlineSize: 'max-content'
});
const $9b6475faece45dc4$var$textAreaStyles = (0, $ecnYn.xcss)({
    width: '567px'
});
const $9b6475faece45dc4$var$textAreaBodyStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.500',
    paddingBottom: 'space.300'
});
const $9b6475faece45dc4$var$closeButtonStyles = (0, $ecnYn.xcss)({
    paddingRight: 'space.050',
    paddingTop: 'space.200',
    textAlign: 'right',
    minInlineSize: 'max-content'
});
const $9b6475faece45dc4$var$listItemWrapperStyles = (0, $ecnYn.xcss)({
    marginBlock: 'space.300'
});
const $9b6475faece45dc4$var$buttonWrapperStyles = (0, $ecnYn.xcss)({
    width: '100%',
    paddingTop: 'space.300',
    paddingBottom: 'space.100',
    textAlign: 'right'
});
const $9b6475faece45dc4$var$imageStyles = null;
const $9b6475faece45dc4$var$ModalComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { isSiteAdmin: isSiteAdmin, stop: stop } = t0;
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            {
                title: (0, $jupik.i18n).teamCalendarsTitle,
                bodyText: (0, $jupik.i18n).teamCalendarsBodyText,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
                featureKey: (0, $oCj79.PremiumFeatureKey).TEAM_CALENDAR
            },
            {
                title: (0, $jupik.i18n).automationTitle,
                bodyText: (0, $jupik.i18n).automationBodyText,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))),
                featureKey: (0, $oCj79.PremiumFeatureKey).AUTOMATION
            },
            {
                title: (0, $jupik.i18n).analyticsTitle,
                bodyText: (0, $jupik.i18n).analyticsBodyTextPTO2,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))),
                featureKey: (0, $oCj79.PremiumFeatureKey).ANALYTICS
            }
        ];
        $[0] = t1;
    } else t1 = $[0];
    const sharedFeaturesMapper = t1;
    let t2;
    if ($[1] !== createAnalyticsEvent || $[2] !== stop) {
        t2 = async (actionSubjectId)=>{
            actionSubjectId && createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: actionSubjectId,
                    source: "premiumTrialOnboardingReverseTrialModal"
                }
            }).fire();
            setIsOpen(false);
            stop?.();
        };
        $[1] = createAnalyticsEvent;
        $[2] = stop;
        $[3] = t2;
    } else t2 = $[3];
    const closeModal = t2;
    let t3;
    let t4;
    if ($[4] !== createAnalyticsEvent || $[5] !== isSiteAdmin) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "premiumTrialOnboardingReverseTrialModal",
                    attributes: {
                        isSiteAdmin: isSiteAdmin
                    }
                }
            }).fire();
        };
        t4 = [
            createAnalyticsEvent,
            isSiteAdmin
        ];
        $[4] = createAnalyticsEvent;
        $[5] = isSiteAdmin;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [
            $9b6475faece45dc4$var$i18n.atlassianAIAdditionalFeatureText,
            $9b6475faece45dc4$var$i18n.whiteboardAdditionalFeatureText,
            $9b6475faece45dc4$var$i18n.bulkContentToolsAdditionalFeatureText,
            $9b6475faece45dc4$var$i18n.advancePermissionsAdditionalFeatureText
        ];
        $[8] = t5;
    } else t5 = $[8];
    const additionalFeaturesList = t5;
    let t6;
    if ($[9] !== Modal || $[10] !== closeModal || $[11] !== isOpen) {
        t6 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            onClose: closeModal,
            autoFocus: false,
            width: 712,
            shouldScrollInViewport: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "stretch"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $9b6475faece45dc4$var$imageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9iADO))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($9iADO))),
            alt: "Premium trial onboarding illustration",
            className: (0, $gMc0m.default)([
                "_5ral1dfr _1tke1osq _1bsb93m8 _4t3i1kdj"
            ])
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            xcss: $9b6475faece45dc4$var$textAreaStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $9b6475faece45dc4$var$closeButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "link",
            onClick: ()=>closeModal("premiumTrialOnboardingReverseTrialModalCloseButton")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            spacing: "spacious",
            label: "Close Modal",
            color: "var(--ds-text, #292A2E)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $9b6475faece45dc4$var$textAreaBodyStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "medium",
            as: "h1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $jupik.i18n).modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            size: "small",
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            ...$9b6475faece45dc4$var$i18n.modalBodyText,
            values: {
                n: sharedFeaturesMapper.length
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $9b6475faece45dc4$var$listItemWrapperStyles
        }, sharedFeaturesMapper.map($9b6475faece45dc4$var$_temp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $9b6475faece45dc4$var$i18n.additionalFeaturesTitle)), additionalFeaturesList.map($9b6475faece45dc4$var$_temp2), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $9b6475faece45dc4$var$buttonWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dqdrq.GradientCTAButton), {
            onClick: ()=>closeModal("premiumTrialOnboardingReverseTrialModalExploreFeatures")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $jupik.i18n).buttonText)))))));
        $[9] = Modal;
        $[10] = closeModal;
        $[11] = isOpen;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, t6));
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : ({ isSiteAdmin: isSiteAdmin, stop: stop })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const sharedFeaturesMapper = [
        {
            title: (0, $jupik.i18n).teamCalendarsTitle,
            bodyText: (0, $jupik.i18n).teamCalendarsBodyText,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
            featureKey: (0, $oCj79.PremiumFeatureKey).TEAM_CALENDAR
        },
        {
            title: (0, $jupik.i18n).automationTitle,
            bodyText: (0, $jupik.i18n).automationBodyText,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))),
            featureKey: (0, $oCj79.PremiumFeatureKey).AUTOMATION
        },
        {
            title: (0, $jupik.i18n).analyticsTitle,
            bodyText: (0, $jupik.i18n).analyticsBodyTextPTO2,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))),
            featureKey: (0, $oCj79.PremiumFeatureKey).ANALYTICS
        }
    ];
    const closeModal = (0, $42omo.useCallback)(async (actionSubjectId)=>{
        actionSubjectId && createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: actionSubjectId,
                source: 'premiumTrialOnboardingReverseTrialModal'
            }
        }).fire();
        setIsOpen(false);
        stop?.();
    }, [
        createAnalyticsEvent,
        stop
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'premiumTrialOnboardingReverseTrialModal',
                attributes: {
                    isSiteAdmin: isSiteAdmin
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSiteAdmin
    ]);
    const additionalFeaturesList = [
        $9b6475faece45dc4$var$i18n.atlassianAIAdditionalFeatureText,
        $9b6475faece45dc4$var$i18n.whiteboardAdditionalFeatureText,
        $9b6475faece45dc4$var$i18n.bulkContentToolsAdditionalFeatureText,
        $9b6475faece45dc4$var$i18n.advancePermissionsAdditionalFeatureText
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        onClose: closeModal,
        autoFocus: false,
        width: 712,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $9b6475faece45dc4$var$imageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9iADO))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($9iADO))),
        // eslint-disable-next-line no-restricted-syntax
        alt: "Premium trial onboarding illustration",
        className: (0, $gMc0m.default)([
            "_5ral1dfr _1tke1osq _1bsb93m8 _4t3i1kdj"
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $9b6475faece45dc4$var$textAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $9b6475faece45dc4$var$closeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        onClick: ()=>closeModal('premiumTrialOnboardingReverseTrialModalCloseButton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        spacing: "spacious",
        label: "Close Modal",
        color: "var(--ds-text, #292A2E)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $9b6475faece45dc4$var$textAreaBodyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $jupik.i18n).modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        ...$9b6475faece45dc4$var$i18n.modalBodyText,
        values: {
            n: sharedFeaturesMapper.length
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $9b6475faece45dc4$var$listItemWrapperStyles
    }, sharedFeaturesMapper.map((feature)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9eYxl.ListItem), {
            key: feature.featureKey,
            bodyText: feature.bodyText,
            icon: feature.icon,
            title: feature.title
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $9b6475faece45dc4$var$i18n.additionalFeaturesTitle)), additionalFeaturesList.map((feature_0, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.100",
            key: `additional-feature-${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), feature_0)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $9b6475faece45dc4$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dqdrq.GradientCTAButton), {
        onClick: ()=>closeModal('premiumTrialOnboardingReverseTrialModalExploreFeatures')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), (0, $jupik.i18n).buttonText)))))))));
};
const $9b6475faece45dc4$export$6217f71eee597ae8 = (0, $f7Bnv.withIsSiteAdmin)($9b6475faece45dc4$var$ModalComponent);
function $9b6475faece45dc4$var$_temp(feature) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9eYxl.ListItem), {
        key: feature.featureKey,
        bodyText: feature.bodyText,
        icon: feature.icon,
        title: feature.title
    });
}
function $9b6475faece45dc4$var$_temp2(feature_0, i) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        key: `additional-feature-${i}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), feature_0)));
}



var $dc00l = parcelRequire("dc00l");


var $kkAiW = parcelRequire("kkAiW");





var $6mKj3 = parcelRequire("6mKj3");


var $kOUwv = parcelRequire("kOUwv");


var $917iu = parcelRequire("917iu");



const $20b9873edeb5d177$export$2be2b82204972a2b = ()=>{
    if (!(0, $9wGTI.fg)('confluence_autoprovisioning_disable_premium_modal')) return false;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const siteTraits = (0, $kOUwv.useSiteTraits)({
        skipBootstrap: !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_autoprovisioning_edition_parity', 'cohort', 'variation')
    });
    const isAutoProvisionedTrait = siteTraits?.data?.attributes?.find((attribute)=>attribute.name === 'is_jira_confluence_d0_auto-provisioned');
    const autoProvisionedDateTrait = siteTraits?.data?.attributes?.find((attribute)=>attribute.name === 'confluence.auto-provision.activationDate');
    if (!isAutoProvisionedTrait?.value || !autoProvisionedDateTrait || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_autoprovisioning_edition_parity', 'cohort', 'variation')) return false;
    try {
        return (0, $917iu.default)(new Date(), (0, $da71s.default)(autoProvisionedDateTrait.value)) <= 90;
    } catch  {
        return false;
    }
};


const $5b737fae830a72d6$var$PREMIUM_ONBOARDING_MESSAGE_ID = 'confluence-premium-onboarding';
const $5b737fae830a72d6$var$MID_TRIAL_PREMIUM_ONBOARDING_MESSAGE_ID = 'upflow-confluence-persistent-upgrade';
const $5b737fae830a72d6$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $5b737fae830a72d6$export$96de03f0565f781d = (0, $da71s.default)('2025-12-09T23:00:00.000Z'); // Dec 9, 2025 3PST / 6EST
const $5b737fae830a72d6$var$CoordinationWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { messageId: messageId, children: children } = t0;
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const hasInitializedRef = (0, $42omo.useRef)(false);
    const postOfficeProxy = (0, $aXjWU.usePostOfficeExernalMessageProxy)(messageId);
    let t1;
    if ($[0] !== postOfficeProxy) {
        t1 = ()=>{
            postOfficeProxy.requestMessageStart();
        };
        $[0] = postOfficeProxy;
        $[1] = t1;
    } else t1 = $[1];
    const initWithPostOffice = t1;
    const isPremiumOnboardingMessage = messageId === $5b737fae830a72d6$var$PREMIUM_ONBOARDING_MESSAGE_ID;
    const isLicensedUser = isLicensed && userId;
    const t2 = userId;
    let t3;
    if ($[2] !== cloudId || $[3] !== t2) {
        t3 = {
            cloudId: cloudId,
            userId: t2
        };
        $[2] = cloudId;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = !isLicensedUser || !isPremiumOnboardingMessage;
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
        t5 = {
            variables: t3,
            skip: t4
        };
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const { data: userPersonalizationData, loading: userPersonalizationDataLoading } = (0, $gqypm.useExperimentalSiteUserPersonalization)(t5);
    const attributes = userPersonalizationData?.experimentalSiteUserPersonalization?.attributes;
    let t6;
    if ($[8] !== attributes) {
        const confluenceFirstActive = attributes?.find($5b737fae830a72d6$var$_temp)?.value;
        const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
        t6 = firstActiveDate && (0, $cFEpk.default)(firstActiveDate) ? (0, $e0SBo.default)(firstActiveDate, $5b737fae830a72d6$export$96de03f0565f781d) : false;
        $[8] = attributes;
        $[9] = t6;
    } else t6 = $[9];
    const isNewUserAfterPOCutover = t6;
    const isMessageActive = postOfficeProxy.hasMessageStarted ?? false;
    let t7;
    let t8;
    if ($[10] !== initWithPostOffice || $[11] !== isMessageActive || $[12] !== isNewUserAfterPOCutover || $[13] !== isPremiumOnboardingMessage || $[14] !== postOfficeProxy) {
        t7 = ()=>{
            if (hasInitializedRef.current) return;
            if (!isPremiumOnboardingMessage || isNewUserAfterPOCutover) {
                hasInitializedRef.current = true;
                initWithPostOffice();
            }
            return ()=>{
                if (isMessageActive) postOfficeProxy.dismissMessage();
            };
        };
        t8 = [
            isNewUserAfterPOCutover,
            isMessageActive,
            isPremiumOnboardingMessage,
            initWithPostOffice,
            postOfficeProxy
        ];
        $[10] = initWithPostOffice;
        $[11] = isMessageActive;
        $[12] = isNewUserAfterPOCutover;
        $[13] = isPremiumOnboardingMessage;
        $[14] = postOfficeProxy;
        $[15] = t7;
        $[16] = t8;
    } else {
        t7 = $[15];
        t8 = $[16];
    }
    (0, $42omo.useEffect)(t7, t8);
    let t9;
    if ($[17] !== postOfficeProxy) {
        t9 = ()=>{
            postOfficeProxy.dismissMessage();
        };
        $[17] = postOfficeProxy;
        $[18] = t9;
    } else t9 = $[18];
    const stop = t9;
    if (!isMessageActive || userPersonalizationDataLoading) return null;
    let t10;
    if ($[19] !== children || $[20] !== stop) {
        t10 = children({
            stop: stop
        });
        $[19] = children;
        $[20] = stop;
        $[21] = t10;
    } else t10 = $[21];
    return t10;
} : ({ messageId: messageId, children: children })=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const hasInitializedRef = (0, $42omo.useRef)(false);
    const postOfficeProxy = (0, $aXjWU.usePostOfficeExernalMessageProxy)(messageId);
    const initWithPostOffice = (0, $42omo.useCallback)(()=>{
        postOfficeProxy.requestMessageStart();
    }, [
        postOfficeProxy
    ]);
    const isPremiumOnboardingMessage = messageId === $5b737fae830a72d6$var$PREMIUM_ONBOARDING_MESSAGE_ID;
    const isLicensedUser = isLicensed && userId;
    /**
   * Most modals that share PREMIUM_ONBOARDING_MESSAGE_ID have specific targeting criteria to render
   * However, the generic PremiumAdminOnboarding and PremiumUserOnboarding modals being returned at the end do not
   *
   * The original EP message was not managed through a trait resulting in no transferable record of users who viewed the nudge
   * This means users who have viewed it before will be eligible to see it again in PO
   * To prevent this, the simplest solution is to ensure only new users after the PO cutover are eligible
   *
   * For future messages in this file, a new PO message should be created
   */ const { data: userPersonalizationData, loading: userPersonalizationDataLoading } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !isLicensedUser || !isPremiumOnboardingMessage
    });
    const attributes = userPersonalizationData?.experimentalSiteUserPersonalization?.attributes;
    const confluenceFirstActive = attributes?.find(({ name: name })=>name === $5b737fae830a72d6$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const isNewUserAfterPOCutover = firstActiveDate && (0, $cFEpk.default)(firstActiveDate) ? (0, $e0SBo.default)(firstActiveDate, $5b737fae830a72d6$export$96de03f0565f781d) : false;
    const isMessageActive = postOfficeProxy.hasMessageStarted ?? false;
    (0, $42omo.useEffect)(()=>{
        if (hasInitializedRef.current) return;
        if (!isPremiumOnboardingMessage || isNewUserAfterPOCutover) {
            hasInitializedRef.current = true;
            initWithPostOffice();
        }
        // clean up function to allow other coordinated messsages to show
        return ()=>{
            if (isMessageActive) postOfficeProxy.dismissMessage();
        };
    }, [
        isNewUserAfterPOCutover,
        isMessageActive,
        isPremiumOnboardingMessage,
        initWithPostOffice,
        postOfficeProxy
    ]);
    const stop = (0, $42omo.useCallback)(()=>{
        postOfficeProxy.dismissMessage();
    }, [
        postOfficeProxy
    ]);
    if (!isMessageActive || userPersonalizationDataLoading) return null;
    return children({
        stop: stop
    });
};
const $5b737fae830a72d6$export$e1028d6b86a91d21 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(30);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isNewUser: isNewUser, isSiteAdmin: isSiteAdmin, error: error, loading: loading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            isPremiumOnboardingEnabled: (0, $9wGTI.fg)("cc_onboarding_experience")
        };
        $[0] = t0;
    } else t0 = $[0];
    const { isPremiumOnboardingFeatureDiscoveryEnabled: isPremiumOnboardingFeatureDiscoveryEnabled, isPTORTEnabled: isPTORTEnabled, inTrialError: experimentInTrialQueryError, reverseTrialError: experimentReverseTrialQueryError, loading: experimentPremiumOnboardModalLoading, trialDaysLeft: trialDaysLeft } = (0, $bC5Yk.useIsPremiumOnboardingFeatureDiscoveryEnabled)(t0);
    const shouldShowPremiumTrialDigestDataModal = trialDaysLeft <= 5 && trialDaysLeft > 0 && isSiteAdmin && edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    let t1;
    if ($[1] !== isPTORTEnabled || $[2] !== isSiteAdmin) {
        t1 = {
            isPTORTEnabled: isPTORTEnabled,
            isSiteAdmin: isSiteAdmin
        };
        $[1] = isPTORTEnabled;
        $[2] = isSiteAdmin;
        $[3] = t1;
    } else t1 = $[3];
    const { showPTORTModal: showPTORTModal, showMidTrialModal: showPTORTMidTrialModal, loading: checkPTOModalVisibilityLoading } = (0, $dc00l.usePTOModalVisibilityOnReverseTrial)(t1);
    let t2;
    if ($[4] !== isPTORTEnabled || $[5] !== showPTORTMidTrialModal || $[6] !== trialDaysLeft) {
        t2 = isPTORTEnabled ? showPTORTMidTrialModal : (0, $kkAiW.getIsTrialInLast15Days)(trialDaysLeft);
        $[4] = isPTORTEnabled;
        $[5] = showPTORTMidTrialModal;
        $[6] = trialDaysLeft;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== isPremiumOnboardingFeatureDiscoveryEnabled || $[9] !== isSiteAdmin || $[10] !== t2) {
        t3 = {
            isPremiumOnboardingFeatureDiscoveryEnabled: isPremiumOnboardingFeatureDiscoveryEnabled,
            isSiteAdmin: isSiteAdmin,
            isTrialHalfWayThrough: t2
        };
        $[8] = isPremiumOnboardingFeatureDiscoveryEnabled;
        $[9] = isSiteAdmin;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    const { shouldShowMidTrialPremiumOnboardingModal: shouldShowMidTrialPremiumOnboardingModal, stopMidTrialPremiumOnboardingModal: stopMidTrialPremiumOnboardingModal } = (0, $3930d3a1cd3fdaa5$export$16232afca5e2d5d1)(t3);
    const isConfluenceAutoprovisionEditionParity = (0, $20b9873edeb5d177$export$2be2b82204972a2b)();
    if (isConfluenceAutoprovisionEditionParity) return null;
    if (edition !== (0, $euL71.ConfluenceEdition).PREMIUM || isNewUser || error || loading || experimentPremiumOnboardModalLoading || checkPTOModalVisibilityLoading || !(0, $9wGTI.fg)("cc_onboarding_experience")) return null;
    if (experimentInTrialQueryError) {
        let t4;
        if ($[12] !== experimentInTrialQueryError) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: experimentInTrialQueryError
            });
            $[12] = experimentInTrialQueryError;
            $[13] = t4;
        } else t4 = $[13];
        return t4;
    }
    if (experimentReverseTrialQueryError) {
        let t4;
        if ($[14] !== experimentReverseTrialQueryError) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: experimentReverseTrialQueryError
            });
            $[14] = experimentReverseTrialQueryError;
            $[15] = t4;
        } else t4 = $[15];
        return t4;
    }
    if (isPTORTEnabled && !showPTORTModal && !shouldShowMidTrialPremiumOnboardingModal) return null;
    if (shouldShowPremiumTrialDigestDataModal) {
        let t4;
        if ($[16] !== trialDaysLeft) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c3062fd9bd4bc3d6$export$fbc613eb80844f6d), {
                daysLeft: trialDaysLeft
            });
            $[16] = trialDaysLeft;
            $[17] = t4;
        } else t4 = $[17];
        return t4;
    }
    if (shouldShowMidTrialPremiumOnboardingModal) {
        const source = isPTORTEnabled && showPTORTMidTrialModal ? "premiumTrialOnboardingReverseTrialMidtrialModal" : "premiumTrialOnboardingModal";
        let t4;
        if ($[18] !== source) {
            t4 = {
                componentSource: source,
                triggerFrom: (0, $jupik.TriggerFrom).MID_TRIAL_ONBOARDING
            };
            $[18] = source;
            $[19] = t4;
        } else t4 = $[19];
        let t5;
        if ($[20] !== source || $[21] !== stopMidTrialPremiumOnboardingModal || $[22] !== trialDaysLeft) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b737fae830a72d6$var$CoordinationWrapper, {
                messageId: $5b737fae830a72d6$var$MID_TRIAL_PREMIUM_ONBOARDING_MESSAGE_ID
            }, (t6)=>{
                const { stop: stop } = t6;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jupik.PremiumTrialOnboardingModal), {
                    daysLeft: trialDaysLeft,
                    triggerFrom: (0, $jupik.TriggerFrom).MID_TRIAL_ONBOARDING,
                    onClose: ()=>{
                        stopMidTrialPremiumOnboardingModal();
                        stop();
                    },
                    source: source
                });
            });
            $[20] = source;
            $[21] = stopMidTrialPremiumOnboardingModal;
            $[22] = trialDaysLeft;
            $[23] = t5;
        } else t5 = $[23];
        let t6;
        if ($[24] !== t4 || $[25] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3F1Fd.RtNeutralMessagingSuppressComponentsHocLoadable), {
                extraAnalyticsAttributes: t4
            }, t5);
            $[24] = t4;
            $[25] = t5;
            $[26] = t6;
        } else t6 = $[26];
        return t6;
    }
    if (isPremiumOnboardingFeatureDiscoveryEnabled && (0, $eXOow.getIsPremiumOnboardingHappened)(true)) (0, $eXOow.setIsPremiumOnboardingHappened)(false);
    if (showPTORTModal) {
        let t4;
        if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3F1Fd.RtNeutralMessagingSuppressComponentsHocLoadable), {
                extraAnalyticsAttributes: {
                    componentSource: "PremiumTrialOnboardingReverseTrialModal"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b737fae830a72d6$var$CoordinationWrapper, {
                messageId: $5b737fae830a72d6$var$PREMIUM_ONBOARDING_MESSAGE_ID
            }, $5b737fae830a72d6$var$_temp2));
            $[27] = t4;
        } else t4 = $[27];
        return t4;
    }
    if (isPremiumOnboardingFeatureDiscoveryEnabled && !isPTORTEnabled) {
        let t4;
        if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b737fae830a72d6$var$CoordinationWrapper, {
                messageId: $5b737fae830a72d6$var$PREMIUM_ONBOARDING_MESSAGE_ID
            }, $5b737fae830a72d6$var$_temp3);
            $[28] = t4;
        } else t4 = $[28];
        return t4;
    }
    let t4;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0g3Y7.AdminKeyEligibilityQuery), null, $5b737fae830a72d6$var$_temp4);
        $[29] = t4;
    } else t4 = $[29];
    return t4;
} : ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isNewUser: isNewUser, isSiteAdmin: isSiteAdmin, error: error, loading: loading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { isPremiumOnboardingFeatureDiscoveryEnabled: isPremiumOnboardingFeatureDiscoveryEnabled, isPTORTEnabled: isPTORTEnabled, inTrialError: experimentInTrialQueryError, reverseTrialError: experimentReverseTrialQueryError, loading: experimentPremiumOnboardModalLoading, trialDaysLeft: trialDaysLeft } = (0, $bC5Yk.useIsPremiumOnboardingFeatureDiscoveryEnabled)({
        isPremiumOnboardingEnabled: (0, $9wGTI.fg)('cc_onboarding_experience')
    });
    const shouldShowPremiumTrialDigestDataModal = trialDaysLeft <= 5 && trialDaysLeft > 0 && isSiteAdmin && edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { showPTORTModal: showPTORTModal, showMidTrialModal: showPTORTMidTrialModal, loading: checkPTOModalVisibilityLoading } = (0, $dc00l.usePTOModalVisibilityOnReverseTrial)({
        isPTORTEnabled: isPTORTEnabled,
        isSiteAdmin: isSiteAdmin
    });
    const { shouldShowMidTrialPremiumOnboardingModal: shouldShowMidTrialPremiumOnboardingModal, stopMidTrialPremiumOnboardingModal: stopMidTrialPremiumOnboardingModal } = (0, $3930d3a1cd3fdaa5$export$16232afca5e2d5d1)({
        isPremiumOnboardingFeatureDiscoveryEnabled: isPremiumOnboardingFeatureDiscoveryEnabled,
        isSiteAdmin: isSiteAdmin,
        isTrialHalfWayThrough: isPTORTEnabled ? showPTORTMidTrialModal : (0, $kkAiW.getIsTrialInLast15Days)(trialDaysLeft)
    });
    const isConfluenceAutoprovisionEditionParity = (0, $20b9873edeb5d177$export$2be2b82204972a2b)();
    // if confluence is auto provisioned and is in variation for the confluence_autoprovisioning_edition_parity experiment,
    // don't show the premium onboarding modal
    if (isConfluenceAutoprovisionEditionParity) return null;
    if (edition !== (0, $euL71.ConfluenceEdition).PREMIUM || isNewUser || error || loading || experimentPremiumOnboardModalLoading || checkPTOModalVisibilityLoading || !(0, $9wGTI.fg)('cc_onboarding_experience')) return null;
    // We dont want to visually display anything when experiment goes wrong.
    if (experimentInTrialQueryError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: experimentInTrialQueryError
    });
    if (experimentReverseTrialQueryError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: experimentReverseTrialQueryError
    });
    if (isPTORTEnabled && !showPTORTModal && !shouldShowMidTrialPremiumOnboardingModal) return null;
    //render premium trial digest data modal when iPUF eligibility conditions are met
    if (shouldShowPremiumTrialDigestDataModal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c3062fd9bd4bc3d6$export$fbc613eb80844f6d), {
        daysLeft: trialDaysLeft
    });
    // PremiumTrialOnboardingReverseTrialModal maybe returned before shouldShowMidTrialPremiumOnboardingModal becomes true.
    // This means that EP message PREMIUM_ONBOARDING_MESSAGE_ID will start before MID_TRIAL_PREMIUM_ONBOARDING_MESSAGE_ID.
    // However, PREMIUM_ONBOARDING_MESSAGE_ID start will fail because it should have already been exposed before mid trial modal shows.
    // Therefore, the mid trial modal is should be safe to start.
    if (shouldShowMidTrialPremiumOnboardingModal) {
        const source = isPTORTEnabled && showPTORTMidTrialModal ? 'premiumTrialOnboardingReverseTrialMidtrialModal' : 'premiumTrialOnboardingModal';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3F1Fd.RtNeutralMessagingSuppressComponentsHocLoadable), {
            extraAnalyticsAttributes: {
                componentSource: source,
                triggerFrom: (0, $jupik.TriggerFrom).MID_TRIAL_ONBOARDING
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b737fae830a72d6$var$CoordinationWrapper, {
            messageId: $5b737fae830a72d6$var$MID_TRIAL_PREMIUM_ONBOARDING_MESSAGE_ID
        }, ({ stop: stop })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jupik.PremiumTrialOnboardingModal), {
                daysLeft: trialDaysLeft,
                triggerFrom: (0, $jupik.TriggerFrom).MID_TRIAL_ONBOARDING,
                onClose: ()=>{
                    stopMidTrialPremiumOnboardingModal();
                    stop();
                },
                source: source
            });
        }));
    }
    if (isPremiumOnboardingFeatureDiscoveryEnabled && (0, $eXOow.getIsPremiumOnboardingHappened)(true)) (0, $eXOow.setIsPremiumOnboardingHappened)(false);
    if (showPTORTModal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3F1Fd.RtNeutralMessagingSuppressComponentsHocLoadable), {
        extraAnalyticsAttributes: {
            componentSource: 'PremiumTrialOnboardingReverseTrialModal'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b737fae830a72d6$var$CoordinationWrapper, {
        messageId: $5b737fae830a72d6$var$PREMIUM_ONBOARDING_MESSAGE_ID
    }, ({ stop: stop_0 })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9b6475faece45dc4$export$6217f71eee597ae8), {
            stop: stop_0
        });
    }));
    if (isPremiumOnboardingFeatureDiscoveryEnabled && !isPTORTEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b737fae830a72d6$var$CoordinationWrapper, {
        messageId: $5b737fae830a72d6$var$PREMIUM_ONBOARDING_MESSAGE_ID
    }, ({ stop: stop_1 })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jupik.PremiumTrialOnboardingModal), {
            triggerFrom: (0, $jupik.TriggerFrom).ONBOARDING,
            stop: stop_1
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0g3Y7.AdminKeyEligibilityQuery), null, ({ canBeSuperAdmin: canBeSuperAdmin })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b737fae830a72d6$var$CoordinationWrapper, {
            messageId: $5b737fae830a72d6$var$PREMIUM_ONBOARDING_MESSAGE_ID
        }, ({ stop: stop_2 })=>{
            return canBeSuperAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1f943a0e379aa69c$export$a0f4e1fa13a23780), {
                stop: stop_2
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e2563777a1d9d1e5$export$40cf333f862b5beb), {
                stop: stop_2
            });
        });
    });
};
function $5b737fae830a72d6$var$_temp(t0) {
    const { name: name } = t0;
    return name === $5b737fae830a72d6$var$CONFLUENCE_FIRST_ACTIVE_TRAIT;
}
function $5b737fae830a72d6$var$_temp2(t0) {
    const { stop: stop_0 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9b6475faece45dc4$export$6217f71eee597ae8), {
        stop: stop_0
    });
}
function $5b737fae830a72d6$var$_temp3(t0) {
    const { stop: stop_1 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jupik.PremiumTrialOnboardingModal), {
        triggerFrom: (0, $jupik.TriggerFrom).ONBOARDING,
        stop: stop_1
    });
}
function $5b737fae830a72d6$var$_temp4(t0) {
    const { canBeSuperAdmin: canBeSuperAdmin } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b737fae830a72d6$var$CoordinationWrapper, {
        messageId: $5b737fae830a72d6$var$PREMIUM_ONBOARDING_MESSAGE_ID
    }, (t1)=>{
        const { stop: stop_2 } = t1;
        return canBeSuperAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1f943a0e379aa69c$export$a0f4e1fa13a23780), {
            stop: stop_2
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e2563777a1d9d1e5$export$40cf333f862b5beb), {
            stop: stop_2
        });
    });
}
module.exports["POST_OFFICE_CUTOVER_DATE"] = $5b737fae830a72d6$export$96de03f0565f781d;
module.exports["PremiumOnboarding"] = $5b737fae830a72d6$export$e1028d6b86a91d21;

});

parcelRegister("e0SBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33b6ba3d9a58f3b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $a33b6ba3d9a58f3b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("aXjWU", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $42omo.useState)($6d6c82fa2f331bd2$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("0g3Y7", function(module, exports) {

var $47wTh = parcelRequire("47wTh");


var $4xcIM = parcelRequire("4xcIM");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

function $bb950e1e25a27f84$export$8e5be031fba9cbe5({ children: children }) {
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $47wTh.default));
    let errorToReportToChildren;
    let isUnauthorized = false;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) {
            // If `edition` is not permitted to the current user (e.g. anonymous
            // access is not permitted), then the current user is definitely not
            // eligible for admin key. So here an unauthorized error is an expected
            // error.
            (0, $7Sm4c.markErrorAsHandled)(error);
            isUnauthorized = true;
        } else errorToReportToChildren = error;
    }
    return children({
        canBeSuperAdmin: isUnauthorized ? false : Boolean(data?.user?.confluence?.roles?.canBeSuperAdmin),
        edition: isUnauthorized ? undefined : data?.confluenceTenantContext?.editions?.confluence,
        error: errorToReportToChildren,
        loading: loading
    });
}
$bb950e1e25a27f84$export$8e5be031fba9cbe5.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["AdminKeyEligibilityQuery"] = $bb950e1e25a27f84$export$8e5be031fba9cbe5;

});

parcelRegister("47wTh", function(module, exports) {
/**
 * @generated SignedSource<<f2547bb09ab2ab3c5163c025efc21976>>
 * @relayHash ddcb713faea6264b16dad4287cf3b4b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c461db223051b973a34720eaa2600107d2ff9fc02999a23f010aa25a82eb6ad
const $2c4160e57f9e3e3f$var$node = function() {
    var v0 = [
        {
            "concreteType": "Tenant",
            "kind": "LinkedField",
            "name": "tenant",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "cloudId"
                }
            ]
        },
        {
            "alias": "confluenceTenantContext",
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Editions",
                    "kind": "LinkedField",
                    "name": "editions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "confluence"
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canBeSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "AdminKeyEligibilityQueryAdminKeyEligibilityQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "AdminKeyEligibilityQueryAdminKeyEligibilityQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "ddcb713faea6264b16dad4287cf3b4b4",
            "id": "9c461db223051b973a34720eaa2600107d2ff9fc02999a23f010aa25a82eb6ad",
            "metadata": {},
            "name": "AdminKeyEligibilityQueryAdminKeyEligibilityQuery",
            "operationKind": "query",
            "text": "query AdminKeyEligibilityQueryAdminKeyEligibilityQuery{tenant{cloudId},confluenceTenantContext:confluence_tenantContext{editions{confluence}},user:confluence_atlassianUser(current:true){id,confluence{roles{canBeSuperAdmin}}}}"
        }
    };
}();
$2c4160e57f9e3e3f$var$node.hash = "f9719ea98536123f3036cf46919010ba";
var $2c4160e57f9e3e3f$export$2e2bcd8739ae039 = $2c4160e57f9e3e3f$var$node;
module.exports["default"] = $2c4160e57f9e3e3f$export$2e2bcd8739ae039;

});

parcelRegister("9bxvy", function(module, exports) {

let $6aff2217b86e005e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6aff2217b86e005e$var$load("5tmW9"),
    $6aff2217b86e005e$var$load("6wr18"),
    $6aff2217b86e005e$var$load("cyGuT"),
    $6aff2217b86e005e$var$load("ffEVr"),
    $6aff2217b86e005e$var$load("jXx9i"),
    $6aff2217b86e005e$var$load("7EorR"),
    $6aff2217b86e005e$var$load("hhss7"),
    $6aff2217b86e005e$var$load("Wowvf"),
    $6aff2217b86e005e$var$load("4Nzvy"),
    $6aff2217b86e005e$var$load("f88d4")
]).then(()=>parcelRequire('eB7KF'));

});

parcelRegister("3F1Fd", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $fe58a4780c2503a7$export$1f697d906c4a3b2b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "avS72",
    name: "RtNeutralMessagingSuppressComponentsHocLoadable",
    loader: async ()=>(await (parcelRequire("a90OW"))).RtNeutralMessagingSuppressComponentsHocWithErrorBoundary
});
module.exports["RtNeutralMessagingSuppressComponentsHocLoadable"] = $fe58a4780c2503a7$export$1f697d906c4a3b2b;

});

parcelRegister("a90OW", function(module, exports) {

let $762b61a052416d96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $762b61a052416d96$var$load("dTz74").then(()=>parcelRequire('12mRL'));

});

parcelRegister("gqypm", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip
    });
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("kRW4Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $T1bCI.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("jZuqn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $4kjfc = parcelRequire("4kjfc");

const $62e9909ce239e1d8$var$packageName = "platform-pkg";
const $62e9909ce239e1d8$var$packageVersion = "0.0.0-use.local";
const $62e9909ce239e1d8$var$progressIndicatorGapMap = {
    comfortable: {
        default: 'space.100',
        large: 'space.150'
    },
    cozy: {
        default: 'space.075',
        large: 'space.100'
    },
    compact: {
        default: 'space.050',
        large: 'space.075'
    }
};
const $62e9909ce239e1d8$var$sizes = {
    default: 8,
    large: 12
};
const $62e9909ce239e1d8$var$varDotsSize = '--ds-dots-size';
const $62e9909ce239e1d8$var$varDotsMargin = '--ds-dots-margin';
/**
 * __ProgressDots__
 *
 * A progress indicator shows the user where they are along the steps of a journey.
 */ const $62e9909ce239e1d8$var$ProgressDots = ({ appearance: appearance = 'default', ariaControls: ariaControls = 'panel', ariaLabel: ariaLabel = 'tab', size: size = 'default', // NOTE: `spacing` is a reserved HTML attribute and will be added to the
// element, replaced with `gutter`.
spacing: gutter = 'comfortable', selectedIndex: selectedIndex, testId: testId, values: values, onSelect: onSelect })=>{
    const tablistRef = (0, $42omo.useRef)(null);
    const onSelectWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onSelect || (0, $ee7An.default),
        action: 'selected',
        componentName: 'progressIndicator',
        packageName: $62e9909ce239e1d8$var$packageName,
        packageVersion: $62e9909ce239e1d8$var$packageVersion
    });
    const gap = $62e9909ce239e1d8$var$progressIndicatorGapMap[gutter][size];
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        const indicators = Array.from(tablistRef.current.children);
        // bail if the target isn't an indicator
        if (!indicators.includes(event.target)) return;
        // bail if not valid arrow key
        const isLeft = event.key === 'ArrowLeft';
        const isRight = event.key === 'ArrowRight';
        if (!isLeft && !isRight) return;
        // bail if at either end of the values
        const isAlpha = isLeft && selectedIndex === 0;
        const isOmega = isRight && selectedIndex === values.length - 1;
        if (isAlpha || isOmega) return;
        const index = isLeft ? selectedIndex - 1 : selectedIndex + 1;
        // call the consumer's select method and focus the applicable indicator
        if (onSelect) onSelectWithAnalytics({
            event: event,
            index: index
        });
        if (typeof indicators[index].focus === 'function') indicators[index].focus();
    }, [
        onSelectWithAnalytics,
        selectedIndex,
        values,
        onSelect
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!onSelect) return 0, $ee7An.default;
        return (0, $fFa3V.bind)(document, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: false
            }
        });
    }, [
        onSelect,
        handleKeyDown
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        style: {
            [$62e9909ce239e1d8$var$varDotsSize]: `${$62e9909ce239e1d8$var$sizes[size]}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$62e9909ce239e1d8$var$varDotsMargin]: gap
        },
        role: onSelect && 'tablist',
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            testId: testId,
            ref: (r)=>{
                tablistRef.current = r;
            },
            alignInline: "center",
            space: gap,
            children: values.map((_, index)=>{
                const isSelected = selectedIndex === index;
                const tabId = `${ariaLabel}${index}`;
                const panelId = `${ariaControls}${index}`;
                const indicatorTestId = testId && `${testId}-ind-${index}`;
                return onSelect ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4kjfc.ButtonIndicator), {
                    testId: indicatorTestId,
                    appearance: appearance,
                    isSelected: isSelected,
                    tabId: tabId,
                    panelId: panelId,
                    onClick: (event)=>onSelectWithAnalytics({
                            event: event,
                            index: index
                        })
                }, index) : /*#__PURE__*/ (0, $l998X.jsx)((0, $4kjfc.PresentationalIndicator), {
                    testId: indicatorTestId,
                    appearance: appearance,
                    isSelected: isSelected
                }, index);
            })
        })
    });
};
var $62e9909ce239e1d8$export$2e2bcd8739ae039 = $62e9909ce239e1d8$var$ProgressDots;
module.exports["default"] = $62e9909ce239e1d8$export$2e2bcd8739ae039;

});

parcelRegister("4kjfc", function(module, exports) {
/* indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");


var $6F6hl = parcelRequire("6F6hl");

const $ab0fca144a05f4f5$var$commonStyles = {
    common: "_2rko1rr0 _1bsbg7kr _4t3ig7kr _kqswh2mm _cfu11ule _1mp41th6 _kfgt1th6 _1cs8stnw _1kt9b3bt _iajm1yh4 _z5wt1yh4"
};
const $ab0fca144a05f4f5$var$colorBorderMap = {
    default: "_19it1axi",
    help: "_19it1axi",
    inverted: "_19it1ps9",
    primary: "_19it1axi"
};
const $ab0fca144a05f4f5$var$buttonStyle = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _80omtlke"
};
const $ab0fca144a05f4f5$var$backgroundColor = (isSelected)=>{
    if (!isSelected) return {
        default: "var(--ds-surface, #FFFFFF)",
        help: "var(--ds-surface, #FFFFFF)",
        inverted: "var(--ds-background-neutral-subtle, #00000000)",
        primary: "var(--ds-surface, #FFFFFF)"
    };
    return {
        default: "var(--ds-icon, #292A2E)",
        help: "var(--ds-icon-discovery, #AF59E1)",
        inverted: "var(--ds-icon-inverse, #FFFFFF)",
        primary: "var(--ds-icon-brand, #1868DB)"
    };
};
const $ab0fca144a05f4f5$export$ec3c81af58a0c4e7 = ({ appearance: appearance, isSelected: isSelected, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: testId,
        // here we set it dynamic because that backgroundColor and xcss don't support the colors we need here eg. token('color.icon')
        style: {
            backgroundColor: $ab0fca144a05f4f5$var$backgroundColor(isSelected)[appearance]
        },
        xcss: (0, $1bHXt.cx)($ab0fca144a05f4f5$var$commonStyles.common, $ab0fca144a05f4f5$var$colorBorderMap[appearance])
    });
};
const $ab0fca144a05f4f5$export$3716cb524d6018c1 = ({ appearance: appearance, panelId: panelId, tabId: tabId, isSelected: isSelected, onClick: onClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        role: "tab",
        style: {
            backgroundColor: $ab0fca144a05f4f5$var$backgroundColor(isSelected)[appearance]
        },
        xcss: (0, $1bHXt.cx)($ab0fca144a05f4f5$var$commonStyles.common, $ab0fca144a05f4f5$var$buttonStyle.root, $ab0fca144a05f4f5$var$colorBorderMap[appearance]),
        "aria-controls": panelId,
        "aria-selected": isSelected,
        id: tabId,
        onClick: onClick,
        tabIndex: isSelected ? -1 : undefined,
        testId: testId,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
            children: tabId
        })
    });
};
module.exports["PresentationalIndicator"] = $ab0fca144a05f4f5$export$ec3c81af58a0c4e7;
module.exports["ButtonIndicator"] = $ab0fca144a05f4f5$export$3716cb524d6018c1;

});

parcelRegister("bC5Yk", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $lzcvT = parcelRequire("lzcvT");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $bnGIh = parcelRequire("bnGIh");


var $8gbsh = parcelRequire("8gbsh");


var $4oZIh = parcelRequire("4oZIh");

const $06ae01438faf2d07$export$aea6e52a413de9e6 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { isPremiumOnboardingEnabled: t2, shouldCheckIsInTrial: t3 } = t1;
    const isPremiumOnboardingEnabled = t2 === undefined ? true : t2;
    const shouldCheckIsInTrial = t3 === undefined ? true : t3;
    const { edition: edition, isLoggedIn: isLoggedIn, isLicensed: isLicensed, userId: userId } = (0, $bQm3c.useSessionData)();
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $lzcvT.isFedRamp)();
        $[2] = t4;
    } else t4 = $[2];
    const isFedrampEnv = t4;
    const isUserAndInstanceEligible = isPremiumOnboardingEnabled && edition === (0, $euL71.ConfluenceEdition).PREMIUM && isLoggedIn && isLicensed && Boolean(userId) && !isFedrampEnv;
    const t5 = !isUserAndInstanceEligible;
    let t6;
    if ($[3] !== t5) {
        t6 = {
            skip: t5
        };
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    const { loading: reverseTrialLoading, error: reverseTrialError, reverseTrialCohort: reverseTrialCohort } = (0, $bnGIh.useReverseTrialEligible)(t6);
    const t7 = !shouldCheckIsInTrial || !isUserAndInstanceEligible;
    let t8;
    if ($[5] !== t7) {
        t8 = {
            skip: t7
        };
        $[5] = t7;
        $[6] = t8;
    } else t8 = $[6];
    const { trialData: trialData, trialDetailsError: trialDetailsError, trialDetailsLoading: trialDetailsLoading, trialDaysLeft: trialDaysLeft, isInstanceInTrial: isInstanceInTrial } = (0, $4oZIh.useTrialDetails)(t8);
    const isReverseTrialEnrolled = reverseTrialCohort === (0, $8gbsh.ReverseTrialCohort).ENROLLED;
    const isPTOEligible = isUserAndInstanceEligible && !reverseTrialLoading && !reverseTrialError;
    const isPTORTEligible = isPTOEligible && isReverseTrialEnrolled;
    const isPremiumOnboardingFeatureDiscoveryEnabled = isPTOEligible && (!shouldCheckIsInTrial || !trialDetailsLoading && !trialDetailsError && isInstanceInTrial);
    const isPTORTEnabled = isPTORTEligible && isPremiumOnboardingFeatureDiscoveryEnabled;
    const t9 = trialDetailsLoading || reverseTrialLoading;
    const t10 = trialData?.license?.trialEndDate;
    let t11;
    if ($[7] !== isPTORTEnabled || $[8] !== isPremiumOnboardingFeatureDiscoveryEnabled || $[9] !== reverseTrialError || $[10] !== t10 || $[11] !== t9 || $[12] !== trialDaysLeft || $[13] !== trialDetailsError) {
        t11 = {
            loading: t9,
            inTrialError: trialDetailsError,
            reverseTrialError: reverseTrialError,
            isPremiumOnboardingFeatureDiscoveryEnabled: isPremiumOnboardingFeatureDiscoveryEnabled,
            isPTORTEnabled: isPTORTEnabled,
            trialDaysLeft: trialDaysLeft,
            trialEndDate: t10
        };
        $[7] = isPTORTEnabled;
        $[8] = isPremiumOnboardingFeatureDiscoveryEnabled;
        $[9] = reverseTrialError;
        $[10] = t10;
        $[11] = t9;
        $[12] = trialDaysLeft;
        $[13] = trialDetailsError;
        $[14] = t11;
    } else t11 = $[14];
    return t11;
} : ({ isPremiumOnboardingEnabled: isPremiumOnboardingEnabled = true, shouldCheckIsInTrial: shouldCheckIsInTrial = true } = {})=>{
    const { edition: edition, isLoggedIn: isLoggedIn, isLicensed: isLicensed, userId: userId } = (0, $bQm3c.useSessionData)();
    const isFedrampEnv = (0, $lzcvT.isFedRamp)();
    const isUserAndInstanceEligible = isPremiumOnboardingEnabled && edition === (0, $euL71.ConfluenceEdition).PREMIUM && isLoggedIn && isLicensed && Boolean(userId) && // FedRamp shouldn't have any premium trial customer but we are excluding it just in case
    !isFedrampEnv;
    const { loading: reverseTrialLoading, error: reverseTrialError, reverseTrialCohort: reverseTrialCohort } = (0, $bnGIh.useReverseTrialEligible)({
        skip: !isUserAndInstanceEligible
    });
    const { trialData: trialData, trialDetailsError: trialDetailsError, trialDetailsLoading: trialDetailsLoading, trialDaysLeft: trialDaysLeft, isInstanceInTrial: isInstanceInTrial } = (0, $4oZIh.useTrialDetails)({
        skip: !shouldCheckIsInTrial || !isUserAndInstanceEligible
    });
    const isReverseTrialEnrolled = reverseTrialCohort === (0, $8gbsh.ReverseTrialCohort).ENROLLED; // checks if it is RT instance
    const isPTOEligible = isUserAndInstanceEligible && !reverseTrialLoading && !reverseTrialError;
    const isPTORTEligible = isPTOEligible && isReverseTrialEnrolled;
    const isPremiumOnboardingFeatureDiscoveryEnabled = isPTOEligible && (!shouldCheckIsInTrial || !trialDetailsLoading && !trialDetailsError && isInstanceInTrial);
    const isPTORTEnabled = isPTORTEligible && isPremiumOnboardingFeatureDiscoveryEnabled;
    return {
        loading: trialDetailsLoading || reverseTrialLoading,
        inTrialError: trialDetailsError,
        reverseTrialError: reverseTrialError,
        isPremiumOnboardingFeatureDiscoveryEnabled: isPremiumOnboardingFeatureDiscoveryEnabled,
        isPTORTEnabled: isPTORTEnabled,
        trialDaysLeft: trialDaysLeft,
        trialEndDate: trialData?.license?.trialEndDate
    };
};
module.exports["useIsPremiumOnboardingFeatureDiscoveryEnabled"] = $06ae01438faf2d07$export$aea6e52a413de9e6;

});

parcelRegister("bnGIh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $8H5XZ = parcelRequire("8H5XZ");


var $7Sm4c = parcelRequire("7Sm4c");




const $96463d3f4390f0c4$export$4695bad538a258b4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {
            skip: false
        } : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: skip } = t1;
    const skipQuery = skip || Boolean(undefined);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $eSUdr.default)`query useReverseTrialEligibleSignUpPropertiesQuery{signUpProperties{reverseTrial}}`;
        $[2] = t2;
    } else t2 = $[2];
    const QUERY_DOC = t2;
    let t3;
    if ($[3] !== skipQuery) {
        t3 = {
            skip: skipQuery
        };
        $[3] = skipQuery;
        $[4] = t3;
    } else t3 = $[4];
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)(QUERY_DOC, t3);
    if ((0, $8H5XZ.isGraphQLError)(error) && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const t4 = data?.signUpProperties?.reverseTrial;
    const t5 = skipQuery ? false : loading;
    const t6 = skipQuery ? null : error;
    let t7;
    if ($[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
        t7 = {
            reverseTrialCohort: t4,
            loading: t5,
            error: t6
        };
        $[5] = t4;
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    return t7;
} : ({ skip: skip } = {
    skip: false
})=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const skipQuery = skip || Boolean(undefined); // Query is not preloaded and can be skipped during SSR to avoid unnecessary requests
    const QUERY_DOC = (0, $eSUdr.default)`query useReverseTrialEligibleSignUpPropertiesQuery{signUpProperties{reverseTrial}}`;
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)(QUERY_DOC, {
        skip: skipQuery
    });
    if ((0, $8H5XZ.isGraphQLError)(error) && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    return {
        reverseTrialCohort: data?.signUpProperties?.reverseTrial,
        loading: skipQuery ? false : loading,
        error: skipQuery ? null : error
    };
};
module.exports["useReverseTrialEligible"] = $96463d3f4390f0c4$export$4695bad538a258b4;

});

parcelRegister("8gbsh", function(module, exports) {
/**
 * @generated SignedSource<<59bdf6903d6eebf2e54af64858adbdfe>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $14320b27f2be49ff$export$8798225e6f84b893 = /*#__PURE__*/ function(ReverseTrialCohort) {
    ReverseTrialCohort["CONTROL"] = "CONTROL";
    ReverseTrialCohort["ENROLLED"] = "ENROLLED";
    ReverseTrialCohort["NOT_ENROLLED"] = "NOT_ENROLLED";
    ReverseTrialCohort["UNASSIGNED"] = "UNASSIGNED";
    ReverseTrialCohort["UNKNOWN"] = "UNKNOWN";
    ReverseTrialCohort["VARIANT"] = "VARIANT";
    return ReverseTrialCohort;
}({});
module.exports["ReverseTrialCohort"] = $14320b27f2be49ff$export$8798225e6f84b893;

});

parcelRegister("4oZIh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $1o4fX = parcelRequire("1o4fX");


var $8H5XZ = parcelRequire("8H5XZ");


var $7Sm4c = parcelRequire("7Sm4c");





var $bQm3c = parcelRequire("bQm3c");

const $539a9f290c7f1955$export$be2f13183561cb = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { skip: t1 } = t0;
    const skip = t1 === undefined ? true : t1;
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const shouldSkipQuery = skip || !isLoggedIn;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $eSUdr.default)`query useTrialDetailsTrialDetailsQuery{license{trialEndDate billingSourceSystem}}`;
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== shouldSkipQuery) {
        t3 = {
            skip: shouldSkipQuery
        };
        $[1] = shouldSkipQuery;
        $[2] = t3;
    } else t3 = $[2];
    const { data: trialData, loading: trialDetailsLoading, error: trialDetailsError } = (0, $j1Ss3.useQuery)(t2, t3);
    if ((0, $8H5XZ.isGraphQLError)(trialDetailsError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(trialDetailsError)) (0, $7Sm4c.markErrorAsHandled)(trialDetailsError);
    let t4;
    if ($[3] !== trialData?.license?.trialEndDate) {
        t4 = (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(trialData?.license?.trialEndDate) ?? 0;
        $[3] = trialData?.license?.trialEndDate;
        $[4] = t4;
    } else t4 = $[4];
    const trialDaysLeft = t4;
    const t5 = trialDaysLeft > 0;
    const t6 = trialData?.license?.trialEndDate;
    const t7 = trialData?.license?.billingSourceSystem;
    let t8;
    if ($[5] !== t5 || $[6] !== t6 || $[7] !== t7 || $[8] !== trialData || $[9] !== trialDaysLeft || $[10] !== trialDetailsError || $[11] !== trialDetailsLoading) {
        t8 = {
            trialData: trialData,
            trialDetailsLoading: trialDetailsLoading,
            trialDetailsError: trialDetailsError,
            isInstanceInTrial: t5,
            trialDaysLeft: trialDaysLeft,
            trialEndDate: t6,
            billingSourceSystem: t7
        };
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
        $[8] = trialData;
        $[9] = trialDaysLeft;
        $[10] = trialDetailsError;
        $[11] = trialDetailsLoading;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : ({ skip: skip = true })=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const shouldSkipQuery = skip || !isLoggedIn;
    const { data: trialData, loading: trialDetailsLoading, error: trialDetailsError } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useTrialDetailsTrialDetailsQuery{license{trialEndDate billingSourceSystem}}`, {
        skip: shouldSkipQuery
    });
    if ((0, $8H5XZ.isGraphQLError)(trialDetailsError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(trialDetailsError)) (0, $7Sm4c.markErrorAsHandled)(trialDetailsError);
    const trialDaysLeft = (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(trialData?.license?.trialEndDate) ?? 0;
    return {
        trialData: trialData,
        trialDetailsLoading: trialDetailsLoading,
        trialDetailsError: trialDetailsError,
        isInstanceInTrial: trialDaysLeft > 0,
        trialDaysLeft: trialDaysLeft,
        trialEndDate: trialData?.license?.trialEndDate,
        billingSourceSystem: trialData?.license?.billingSourceSystem
    };
};
module.exports["useTrialDetails"] = $539a9f290c7f1955$export$be2f13183561cb;

});

parcelRegister("1o4fX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hqNcO = parcelRequire("hqNcO");

function $560b1fdf6e9d95bc$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $hqNcO.MILLISECONDS_IN_A_DAY));
}
function $560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $560b1fdf6e9d95bc$export$954628993bf3188e(trialEndTime - Date.now());
}
function $560b1fdf6e9d95bc$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $560b1fdf6e9d95bc$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $560b1fdf6e9d95bc$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $560b1fdf6e9d95bc$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $560b1fdf6e9d95bc$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $560b1fdf6e9d95bc$export$ee6c4faab08346c;

});

parcelRegister("hqNcO", function(module, exports) {
const $f5358d62f394b358$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $f5358d62f394b358$export$98a7370239de6730;

});

parcelRegister("9oxdN", function(module, exports) {

var $h1PDd = parcelRequire("h1PDd");


var $iaK3p = parcelRequire("iaK3p");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");


var $l1uFv = parcelRequire("l1uFv");


var $7W8i8 = parcelRequire("7W8i8");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery = (0, $iaK3p.default);
const $112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation = (0, $h1PDd.default);
const $112f5732a615f62f$var$logger = (0, $7W8i8.getLogger)('useFeatureDiscovery');
const $112f5732a615f62f$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $112f5732a615f62f$var$updateCache = (_, { data: data })=>{
    const newMarkedFeature = data?.markFeatureDiscovered;
    if (!newMarkedFeature) return;
    const cachedFeatureData = (0, $l1uFv.readQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery
    });
    if (!cachedFeatureData?.featureDiscovery) return;
    (0, $fEmGS.writeQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        data: {
            featureDiscovery: cachedFeatureData.featureDiscovery.concat(newMarkedFeature)
        }
    });
};
const $112f5732a615f62f$var$getLocalOverrideValue = (featureKey)=>{
    try {
        if ((0, $17wUi.confluenceSessionStorageInstance).getItem((0, $9wGTI.fg)('confluence_browser_storage_prepended_keys') ? `${featureKey}-featureDiscoveryOverride` : `${(0, $1UApO.keys).FEATURE_DISCOVERY_OVERRIDE_PREFIX}-${featureKey}`)) return true;
    } catch (e) {
        $112f5732a615f62f$var$logger.error(e);
    }
    return false;
};
const $112f5732a615f62f$var$noop = ()=>{};
const $112f5732a615f62f$export$6de1a7573792d1a9 = (featureKey, skip)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const skipFeatureDiscoveryQuery = !isLoggedIn || skip;
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery, {
        skip: skipFeatureDiscoveryQuery
    });
    const [markFeatureDiscovered, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation, {
        variables: {
            featureKey: featureKey,
            pluginKey: $112f5732a615f62f$export$2dd355223baa0569
        },
        update: $112f5732a615f62f$var$updateCache
    });
    const loading = queryLoading || mutationLoading;
    const error = queryError || mutationError;
    const showFeature = !loading && !error && !data?.featureDiscovery?.some((feature)=>feature?.pluginKey === $112f5732a615f62f$export$2dd355223baa0569 && feature?.featureKey === featureKey);
    const handleStop = (0, $42omo.useCallback)(()=>{
        if (showFeature) // error is handled in the useMutation result
        markFeatureDiscovered().catch(()=>{});
    }, [
        showFeature,
        markFeatureDiscovered
    ]);
    if (skipFeatureDiscoveryQuery) return [
        false,
        $112f5732a615f62f$var$noop,
        undefined
    ];
    // this is for dev/testing, since we cant easily remove data from the featureDiscovery array
    const forceShowFeature = showFeature || $112f5732a615f62f$var$getLocalOverrideValue(featureKey);
    return [
        forceShowFeature,
        handleStop,
        error
    ];
};
module.exports["useFeatureDiscovery"] = $112f5732a615f62f$export$6de1a7573792d1a9;

});

parcelRegister("h1PDd", function(module, exports) {
/**
 * @generated SignedSource<<1c52947b4a05fe02fc1b43b80c341c9c>>
 * @relayHash 7e3a97b41907f84e881bf7535b1379ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081
const $fca31db58911eb73$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "featureKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pluginKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "featureKey",
                    "variableName": "featureKey"
                },
                {
                    "kind": "Variable",
                    "name": "pluginKey",
                    "variableName": "pluginKey"
                }
            ],
            "concreteType": "FeatureDiscoveryPayload",
            "kind": "LinkedField",
            "name": "markFeatureDiscovered",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7e3a97b41907f84e881bf7535b1379ce",
            "id": "aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081",
            "metadata": {},
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "operationKind": "mutation",
            "text": "mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!,$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey,pluginKey:$pluginKey){pluginKey,featureKey}}"
        }
    };
}();
$fca31db58911eb73$var$node.hash = "55ae5a7186fb2a98e37da374a9b9784e";
var $fca31db58911eb73$export$2e2bcd8739ae039 = $fca31db58911eb73$var$node;
module.exports["default"] = $fca31db58911eb73$export$2e2bcd8739ae039;

});

parcelRegister("iaK3p", function(module, exports) {
/**
 * @generated SignedSource<<64599f16afee950a47221dcfc47cc997>>
 * @relayHash 5f15c23509e6cb7f2874b0f92de8a11b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f
const $8d30006ecab20121$var$node = function() {
    var v0 = [
        {
            "concreteType": "DiscoveredFeature",
            "kind": "LinkedField",
            "name": "featureDiscovery",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "5f15c23509e6cb7f2874b0f92de8a11b",
            "id": "8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f",
            "metadata": {},
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "operationKind": "query",
            "text": "query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey,featureKey}}"
        }
    };
}();
$8d30006ecab20121$var$node.hash = "8577be880df828fbee71c90a7701eddf";
var $8d30006ecab20121$export$2e2bcd8739ae039 = $8d30006ecab20121$var$node;
module.exports["default"] = $8d30006ecab20121$export$2e2bcd8739ae039;

});

parcelRegister("fEmGS", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("l1uFv", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("f7Bnv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1ytiN = parcelRequire("1ytiN");

function $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5(WrappedComponent) {
    return function WithIsSiteAdminComponent(props) {
        const { isSiteAdmin: isSiteAdmin, error: error, loading: loading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
        if (error || loading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isSiteAdmin: isSiteAdmin
        });
    };
}
module.exports["withIsSiteAdmin"] = $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5;

});

parcelRegister("dqdrq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $izVB4 = parcelRequire("izVB4");


var $j4WDj = parcelRequire("j4WDj");


var $6J7Bn = parcelRequire("6J7Bn");

const $ce55fe36479bc4cf$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? (0, $6J7Bn.ButtonBase) : t2;
        let t3;
        let t4;
        let t5;
        let t6;
        let t7;
        let t8;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START));
            t4 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END));
            t5 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START));
            t6 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END));
            t7 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START));
            t8 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END));
            $[3] = t3;
            $[4] = t4;
            $[5] = t5;
            $[6] = t6;
            $[7] = t7;
            $[8] = t8;
        } else {
            t3 = $[3];
            t4 = $[4];
            t5 = $[5];
            t6 = $[6];
            t7 = $[7];
            t8 = $[8];
        }
        let t9;
        if ($[9] !== __cmpls) {
            t9 = {
                ...__cmpls,
                "--_iozncj": t3,
                "--_id2ec3": t4,
                "--_1wa1xp5": t5,
                "--_1ck0ygl": t6,
                "--_1jf6nc6": t7,
                "--_1kksnqn": t8
            };
            $[9] = __cmpls;
            $[10] = t9;
        } else t9 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: t9,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1wgmglyw _1tnq12b0 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = (0, $6J7Bn.ButtonBase), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_iozncj": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START)),
            "--_id2ec3": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END)),
            "--_1wa1xp5": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START)),
            "--_1ck0ygl": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END)),
            "--_1jf6nc6": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START)),
            "--_1kksnqn": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1wgmglyw _1tnq12b0 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
            __cmplp.className
        ])
    });
});
const $ce55fe36479bc4cf$var$ButtonText = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
}); /**
     * A styled button with a gradient background, intended to be used as a product edition upgrade CTA button.
     */ 
const $ce55fe36479bc4cf$export$d1aef6466b5ecaa5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    let buttonProps;
    let children;
    if ($[0] !== t0) {
        ({ children: children, ...buttonProps } = t0);
        $[0] = t0;
        $[1] = buttonProps;
        $[2] = children;
    } else {
        buttonProps = $[1];
        children = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        });
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children);
        $[4] = children;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== buttonProps || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$StyledButton, {
            iconBefore: t1,
            ...buttonProps
        }, t2);
        $[6] = buttonProps;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ children: children, ...buttonProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$StyledButton, {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        }),
        ...buttonProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children));
};
module.exports["GradientCTAButton"] = $ce55fe36479bc4cf$export$d1aef6466b5ecaa5;

});

parcelRegister("izVB4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a9109095f0a9b69c0b01202dc3ed5e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8682c67cc42b6ad$var$_react = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("42omo")));

var $d8682c67cc42b6ad$var$_baseNew = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d8682c67cc42b6ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8682c67cc42b6ad$var$EditionsIcon = (props)=>/*#__PURE__*/ $d8682c67cc42b6ad$var$_react.default.createElement($d8682c67cc42b6ad$var$_baseNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.75 1 .096.006a.75.75 0 0 1 .54.347l2.5 4a.75.75 0 0 1-.066.883l-7.25 8.5a.75.75 0 0 1-1.14 0l-7.25-8.5a.75.75 0 0 1-.066-.883l2.5-4 .056-.079A.75.75 0 0 1 3.25 1zM8 11.813 9.719 6.5H6.28zm-1.873-.914L4.704 6.5H2.375zm3.745 0L13.625 6.5h-2.33zM11.302 5h2.596l-1.563-2.5H10.52zM6.27 5h3.46l-.782-2.5H7.052zM2.103 5h2.595l.781-2.5H3.665z"/>`
    }, props));
$d8682c67cc42b6ad$var$EditionsIcon.displayName = 'EditionsIcon';
var $d8682c67cc42b6ad$var$_default = module.exports.default = $d8682c67cc42b6ad$var$EditionsIcon;

});

parcelRegister("j4WDj", function(module, exports) {
const $67193f3c2d75b820$export$3ff4048780acdec9 = "var(--ds-chart-purple-bolder, #AF59E1)";
const $67193f3c2d75b820$export$ac8ee41608bff6f4 = "var(--ds-chart-blue-bolder, #357DE8)";
const $67193f3c2d75b820$export$12fbdde791205cea = "var(--ds-chart-purple-bolder-hovered, #964AC0)";
const $67193f3c2d75b820$export$7653c62635354aaf = "var(--ds-chart-blue-bolder-hovered, #1868DB)";
const $67193f3c2d75b820$export$d4accc94291dcf84 = "var(--ds-chart-purple-boldest, #803FA5)";
const $67193f3c2d75b820$export$16a15d5a9b73591b = "var(--ds-chart-blue-boldest, #1558BC)";
const $67193f3c2d75b820$export$fca70c3c81bb0f58 = "var(--ds-background-accent-blue-subtlest, #E9F2FE)";
const $67193f3c2d75b820$export$f737ffc625de304f = "var(--ds-background-accent-purple-subtlest, #F8EEFE)";
const $67193f3c2d75b820$export$b1ab5fb618714abb = "var(--ds-border-accent-purple, #AF59E1)";
const $67193f3c2d75b820$export$7a262e0e9c5a1e2a = "var(--ds-border-accent-blue, #357DE8)";
const $67193f3c2d75b820$export$71b6aed4f8256b2 = "var(--ds-background-discovery-bold-pressed, #673286)";
const $67193f3c2d75b820$export$c9d89eb8e0b59a5a = "var(--ds-background-selected-bold-pressed, #123263)";
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_START"] = $67193f3c2d75b820$export$3ff4048780acdec9;
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_END"] = $67193f3c2d75b820$export$ac8ee41608bff6f4;
module.exports["GRADIENT_CTA_BUTTON_HOVER_START"] = $67193f3c2d75b820$export$12fbdde791205cea;
module.exports["GRADIENT_CTA_BUTTON_HOVER_END"] = $67193f3c2d75b820$export$7653c62635354aaf;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_START"] = $67193f3c2d75b820$export$d4accc94291dcf84;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_END"] = $67193f3c2d75b820$export$16a15d5a9b73591b;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_START"] = $67193f3c2d75b820$export$fca70c3c81bb0f58;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_END"] = $67193f3c2d75b820$export$f737ffc625de304f;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_START"] = $67193f3c2d75b820$export$b1ab5fb618714abb;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_END"] = $67193f3c2d75b820$export$7a262e0e9c5a1e2a;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_START"] = $67193f3c2d75b820$export$71b6aed4f8256b2;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_END"] = $67193f3c2d75b820$export$c9d89eb8e0b59a5a;

});

parcelRegister("6J7Bn", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");

const $e9beab952dc913a3$export$b0bb876e969289cd = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $eEA8O.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_d16p1ano _1dqt12x7 _1toh1r31 _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_d16p1ano _1dqt12x7 _1toh1r31 _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ])
    });
});
module.exports["ButtonBase"] = $e9beab952dc913a3$export$b0bb876e969289cd;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $4VJDS.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("9iADO", function(module, exports) {
module.exports = new URL("Illustration.bc0cbd7b.svg", import.meta.url).toString();

});

parcelRegister("oCj79", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9oxdN = parcelRequire("9oxdN");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $1ytiN = parcelRequire("1ytiN");


var $4oZIh = parcelRequire("4oZIh");

var $17cf05e6ca75dcaf$export$e066903c3e0dc7e0 = /*#__PURE__*/ function(PremiumFeatureKey) {
    PremiumFeatureKey["ANALYTICS"] = "analytics-used";
    PremiumFeatureKey["AUTOMATION"] = "automation-used";
    PremiumFeatureKey["ADVANCED_PERMISSIONS"] = "advanced-permissions-used";
    PremiumFeatureKey["TEAM_CALENDAR"] = "team-calendar-used";
    PremiumFeatureKey["UNLIMITED_STORAGE"] = "unlimited-storage-used";
    return PremiumFeatureKey;
}({});
var $17cf05e6ca75dcaf$export$141b820167a497fa = /*#__PURE__*/ function(PremiumFeatureUsage) {
    PremiumFeatureUsage["ANALYTICS_VIEW_SPACE"] = "analyticsViewSpace";
    PremiumFeatureUsage["ANALYTICS_VIEW_PAGE"] = "analyticsViewPage";
    PremiumFeatureUsage["AUTOMATION_NEW_RULE"] = "automationNewRule";
    PremiumFeatureUsage["PERMISSIONS_INSPECT_PAGE"] = "permissionsInspectPage";
    PremiumFeatureUsage["TEAM_CALENDAR_CREATE"] = "teamCalendarCreate";
    PremiumFeatureUsage["TEAM_CALENDAR_VIEW"] = "teamCalendarView";
    return PremiumFeatureUsage;
}({});
const $17cf05e6ca75dcaf$var$PremiumFeatureUsage2FeatureDiscoveryKey = {
    ["analyticsViewSpace"]: "analytics-used",
    ["analyticsViewPage"]: "analytics-used",
    ["automationNewRule"]: "automation-used",
    ["permissionsInspectPage"]: "advanced-permissions-used",
    ["teamCalendarCreate"]: "team-calendar-used",
    ["teamCalendarView"]: "team-calendar-used"
};
const $17cf05e6ca75dcaf$export$c9275e1e18a77404 = (0, $3u0dr.isReactCompilerActiveV2)() ? (premiumFeatureUsage, t0)=>{
    const $ = (0, $frIzR.c)(11);
    const skip = t0 === undefined ? false : t0;
    const { edition: edition, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== skip) {
        t1 = {
            skip: skip
        };
        $[0] = skip;
        $[1] = t1;
    } else t1 = $[1];
    const { trialDaysLeft: trialDaysLeft } = (0, $4oZIh.useTrialDetails)(t1);
    const isEligibleToMark = edition === (0, $euL71.ConfluenceEdition).PREMIUM && trialDaysLeft > 0;
    const [, markFeature] = (0, $9oxdN.useFeatureDiscovery)($17cf05e6ca75dcaf$var$PremiumFeatureUsage2FeatureDiscoveryKey[premiumFeatureUsage], !isEligibleToMark);
    let t2;
    if ($[2] !== activationId || $[3] !== createAnalyticsEvent || $[4] !== isEligibleToMark || $[5] !== isSiteAdmin || $[6] !== markFeature || $[7] !== premiumFeatureUsage) {
        t2 = ()=>{
            markFeature();
            if (isEligibleToMark) createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "used",
                    actionSubject: "premiumFeature",
                    source: premiumFeatureUsage,
                    attributes: {
                        activationId: activationId,
                        isSiteAdmin: isSiteAdmin
                    }
                }
            }).fire();
        };
        $[2] = activationId;
        $[3] = createAnalyticsEvent;
        $[4] = isEligibleToMark;
        $[5] = isSiteAdmin;
        $[6] = markFeature;
        $[7] = premiumFeatureUsage;
        $[8] = t2;
    } else t2 = $[8];
    const markFeatureAsUsed = t2;
    let t3;
    if ($[9] !== markFeatureAsUsed) {
        t3 = {
            markFeatureAsUsed: markFeatureAsUsed
        };
        $[9] = markFeatureAsUsed;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (premiumFeatureUsage, skip = false)=>{
    const { edition: edition, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { trialDaysLeft: trialDaysLeft } = (0, $4oZIh.useTrialDetails)({
        skip: skip
    });
    const isEligibleToMark = edition === (0, $euL71.ConfluenceEdition).PREMIUM && trialDaysLeft > 0;
    const [, markFeature] = (0, $9oxdN.useFeatureDiscovery)($17cf05e6ca75dcaf$var$PremiumFeatureUsage2FeatureDiscoveryKey[premiumFeatureUsage], /* skip */ !isEligibleToMark);
    const markFeatureAsUsed = (0, $42omo.useCallback)(()=>{
        markFeature();
        if (isEligibleToMark) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'used',
                actionSubject: 'premiumFeature',
                source: premiumFeatureUsage,
                attributes: {
                    activationId: activationId,
                    isSiteAdmin: isSiteAdmin
                }
            }
        }).fire();
    }, [
        activationId,
        createAnalyticsEvent,
        isEligibleToMark,
        isSiteAdmin,
        markFeature,
        premiumFeatureUsage
    ]);
    return {
        markFeatureAsUsed: markFeatureAsUsed
    };
};
module.exports["PremiumFeatureKey"] = $17cf05e6ca75dcaf$export$e066903c3e0dc7e0;
module.exports["PremiumFeatureUsage"] = $17cf05e6ca75dcaf$export$141b820167a497fa;
module.exports["useTrackPremiumFeatureUsage"] = $17cf05e6ca75dcaf$export$c9275e1e18a77404;

});

parcelRegister("kOUwv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $1P1Tu.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $9zUhf.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $9zUhf.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($26d702ce000cc6e9$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId || !userId) return;
        $26d702ce000cc6e9$var$hasFetched = true;
        storeActions.start();
        $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("7CeAz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cEgMD = parcelRequire("cEgMD");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $8NC5Z = parcelRequire("8NC5Z");

const $16ea73778f65e8da$export$1d4394ae12760637 = ()=>{
    const { frontCoverState: frontCoverState, isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const canPublish = isSiteAdmin || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const isAdminDiscoverable = // 1. If entitled (e.g. Premium), both site admin and product admin have the
    //    entry point in the top nav, because it leads to COMPANY_HUB.
    // 2. If not entitled (e.g. Free or Standard):
    //   a. only site admin has the entry point in the top nav, because it
    //      renders an upsell;
    //   b. product admin doesn't have the entry point in the top nav, because
    //      it automatically redirects to HOME.
    shouldShowPremiumUpsell ? isSiteAdmin : canPublish;
    const isCompanyHubFeatureAvailable = !shouldShowPremiumUpsell;
    const isCompanyHubPublished = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).SHOWN);
    const isCompanyHubShownToEditors = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY || isCompanyHubPublished);
    const isCompanyHubEntryPointEnabled = Boolean(isCompanyHubFeatureAvailable && (isCompanyHubPublished || isCompanyHubShownToEditors) || isAdminDiscoverable);
    return {
        canPublish: isCompanyHubFeatureAvailable && canPublish,
        isCompanyHubPublished: isCompanyHubPublished,
        isCompanyHubShownToEditors: isCompanyHubShownToEditors,
        isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled
    };
};
module.exports["useIsCompanyHubEnabled"] = $16ea73778f65e8da$export$1d4394ae12760637;

});

parcelRegister("8NC5Z", function(module, exports) {

var $896gY = parcelRequire("896gY");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");

const $1de3a5511529eed3$export$f032b5e8b485da1d = ({ skip: skip = false } = {})=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldSkip = skip || edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $896gY.default), {
        skip: shouldSkip
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !shouldSkip && !data?.entitlements?.companyHub?.isEntitled;
};
module.exports["useCompanyHubPremiumGate"] = $1de3a5511529eed3$export$f032b5e8b485da1d;

});

parcelRegister("896gY", function(module, exports) {
/**
 * @generated SignedSource<<f7fbc559eec5624709ee73b4742b3b2c>>
 * @relayHash c31aa70a9a01e2207eb48c0b9be8b493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6
const $983e77d68212dc57$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CompanyHubFeature",
                    "kind": "LinkedField",
                    "name": "companyHub",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c31aa70a9a01e2207eb48c0b9be8b493",
            "id": "46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6",
            "metadata": {},
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "operationKind": "query",
            "text": "query useCompanyHubPremiumGateCompanyHubPremiumGateQuery{entitlements{companyHub{isEntitled}}}"
        }
    };
}();
$983e77d68212dc57$var$node.hash = "a5508e7e7123c5675909c4f9214a5be2";
var $983e77d68212dc57$export$2e2bcd8739ae039 = $983e77d68212dc57$var$node;
module.exports["default"] = $983e77d68212dc57$export$2e2bcd8739ae039;

});

parcelRegister("5qxqN", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $95fd3920e3fd73a4$var$initialState = {
    // doing localStorage check in case it is undefined in testing.
    // localStorage can't be initialized in testing because this block of code is executed first
    isEnabled: (0, $17wUi.confluenceLocalStorageInstance) ? (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_PREMIUM_FEATURE_HIGHLIGHT) === null || (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_PREMIUM_FEATURE_HIGHLIGHT) : true
};
const $95fd3920e3fd73a4$var$actions = {
    update: ()=>({ setState: setState, getState: getState })=>{
            const prevState = getState();
            const isEnabled = !prevState.isEnabled;
            setState({
                isEnabled: isEnabled
            });
            (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_PREMIUM_FEATURE_HIGHLIGHT, isEnabled);
        }
};
const $95fd3920e3fd73a4$var$store = (0, $1P1Tu.createStore)({
    initialState: $95fd3920e3fd73a4$var$initialState,
    actions: $95fd3920e3fd73a4$var$actions,
    name: 'PremiumFeatureHighlightStore'
});
const $95fd3920e3fd73a4$export$8f188abde04b9781 = (0, $9zUhf.createHook)($95fd3920e3fd73a4$var$store);
module.exports["usePremiumFeatureHighlight"] = $95fd3920e3fd73a4$export$8f188abde04b9781;

});


//# sourceMappingURL=PremiumOnboarding.38bd1658.js.map
